export default [
    {
        id: 0,
        name: '常用图库',
        type: [
            {
                id0: 0, name: '泵', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '泵-1',
                        url: '/static/picture/common/泵/泵1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-2',
                        url: '/static/picture/common/泵/泵2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-3',
                        url: '/static/picture/common/泵/泵3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-4',
                        url: '/static/picture/common/泵/泵4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-5',
                        url: '/static/picture/common/泵/泵5.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-6',
                        url: '/static/picture/common/泵/泵6.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-7',
                        url: '/static/picture/common/泵/泵7.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                ],
            },
            {
                id0: 1, name: '传感器', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '传感器-1',
                        url: '/static/picture/common/传感器/传感器1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '传感器-2',
                        url: '/static/picture/common/传感器/传感器2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '传感器-3',
                        url: '/static/picture/common/传感器/传感器3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '传感器-4',
                        url: '/static/picture/common/传感器/传感器4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '传感器-5',
                        url: '/static/picture/common/传感器/传感器5.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '传感器-6',
                        url: '/static/picture/common/传感器/传感器6.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '传感器-7',
                        url: '/static/picture/common/传感器/传感器7.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '传感器-8',
                        url: '/static/picture/common/传感器/传感器8.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                ],
            },
            {
                id0: 2, name: '灯', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '灯-1',
                        url: '/static/picture/common/灯/灯1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '灯-2',
                        url: '/static/picture/common/灯/灯2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '灯-3',
                        url: '/static/picture/common/灯/灯3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '灯-4',
                        url: '/static/picture/common/灯/灯4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '灯-5',
                        url: '/static/picture/common/灯/灯5.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 3, name: '阀', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '阀-1',
                        url: '/static/picture/common/阀/阀1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-2',
                        url: '/static/picture/common/阀/阀2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-3',
                        url: '/static/picture/common/阀/阀3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-4',
                        url: '/static/picture/common/阀/阀4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-5',
                        url: '/static/picture/common/阀/阀5.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-6',
                        url: '/static/picture/common/阀/阀6.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-7',
                        url: '/static/picture/common/阀/阀7.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-8',
                        url: '/static/picture/common/阀/阀8.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 4, name: '管道', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '管道-1',
                        url: '/static/picture/common/管道/封头1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-2',
                        url: '/static/picture/common/管道/封头2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-3',
                        url: '/static/picture/common/管道/封头3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-4',
                        url: '/static/picture/common/管道/封头4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-5',
                        url: '/static/picture/common/管道/三通1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-6',
                        url: '/static/picture/common/管道/三通2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-7',
                        url: '/static/picture/common/管道/三通3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-8',
                        url: '/static/picture/common/管道/三通4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-9',
                        url: '/static/picture/common/管道/四通.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-10',
                        url: '/static/picture/common/管道/直管道1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-11',
                        url: '/static/picture/common/管道/直管道2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-12',
                        url: '/static/picture/common/管道/直角1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-13',
                        url: '/static/picture/common/管道/直角2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-14',
                        url: '/static/picture/common/管道/直角3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-15',
                        url: '/static/picture/common/管道/直角4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 5, name: '罐体', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '罐体-1',
                        url: '/static/picture/common/罐体/罐体1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-2',
                        url: '/static/picture/common/罐体/罐体2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-3',
                        url: '/static/picture/common/罐体/罐体3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-4',
                        url: '/static/picture/common/罐体/罐体4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-5',
                        url: '/static/picture/common/罐体/罐体5.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-6',
                        url: '/static/picture/common/罐体/罐体6.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-7',
                        url: '/static/picture/common/罐体/罐体7.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-8',
                        url: '/static/picture/common/罐体/罐体8.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-9',
                        url: '/static/picture/common/罐体/罐体9.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-10',
                        url: '/static/picture/common/罐体/罐体10.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-11',
                        url: '/static/picture/common/罐体/罐体11.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-12',
                        url: '/static/picture/common/罐体/罐体12.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-13',
                        url: '/static/picture/common/罐体/罐体13.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-14',
                        url: '/static/picture/common/罐体/罐体14.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-15',
                        url: '/static/picture/common/罐体/罐体15.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-16',
                        url: '/static/picture/common/罐体/罐体16.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                ]
            },
            {
                id0: 6, name: '锅炉', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '锅炉-1',
                        url: '/static/picture/common/锅炉/锅炉1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '锅炉-2',
                        url: '/static/picture/common/锅炉/锅炉2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '锅炉-3',
                        url: '/static/picture/common/锅炉/锅炉3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '锅炉-4',
                        url: '/static/picture/common/锅炉/锅炉4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '锅炉-5',
                        url: '/static/picture/common/锅炉/锅炉5.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 7, name: '搅拌', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '搅拌-1',
                        url: '/static/picture/common/搅拌/搅拌1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '搅拌-2',
                        url: '/static/picture/common/搅拌/搅拌2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '搅拌-3',
                        url: '/static/picture/common/搅拌/搅拌3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '搅拌-4',
                        url: '/static/picture/common/搅拌/搅拌4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 8, name: '流量计', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '流量计-1',
                        url: '/static/picture/common/流量计/流量计1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '流量计-2',
                        url: '/static/picture/common/流量计/流量计2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '流量计-3',
                        url: '/static/picture/common/流量计/流量计3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '流量计-4',
                        url: '/static/picture/common/流量计/流量计4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '流量计-5',
                        url: '/static/picture/common/流量计/流量计5.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '流量计-6',
                        url: '/static/picture/common/流量计/流量计6.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '流量计-7',
                        url: '/static/picture/common/流量计/流量计7.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 9, name: '自然', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '自然-1',
                        url: '/static/picture/common/自然/黄花.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-2',
                        url: '/static/picture/common/自然/火焰1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-3',
                        url: '/static/picture/common/自然/火焰2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-4',
                        url: '/static/picture/common/自然/火焰3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-5',
                        url: '/static/picture/common/自然/火焰4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-6',
                        url: '/static/picture/common/自然/火焰5.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-7',
                        url: '/static/picture/common/自然/火焰6.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-8',
                        url: '/static/picture/common/自然/蓝火1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-9',
                        url: '/static/picture/common/自然/蓝火2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-10',
                        url: '/static/picture/common/自然/树木1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-11',
                        url: '/static/picture/common/自然/树木2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-12',
                        url: '/static/picture/common/自然/树木3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                ]
            }

        ],
        showContent: false,
    },
    {
        id: 1,
        name: '工控图库',
        type: [
            {
                id0: 0, name: '按钮旋钮', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '按钮旋钮-1',
                        url: '/static/picture/A/button/fmPressButton_1.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,

                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,

                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-2',
                        url: '/static/picture/A/button/fmPressButton_2.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-3',
                        url: '/static/picture/A/button/fmPressButton_3.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-4',
                        url: '/static/picture/A/button/fmPressButton_4.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-5',
                        url: '/static/picture/A/button/fmPressButton_5.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-6',
                        url: '/static/picture/A/button/fmPressButton_6.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-7',
                        url: '/static/picture/A/button/fmPressButton_7.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-8',
                        url: '/static/picture/A/button/fmPressButton_8.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-9',
                        url: '/static/picture/A/button/fmPressButton_9.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-10',
                        url: '/static/picture/A/button/fmPressButton_10.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ////////////
                    {
                        type: "img",
                        name: '按钮旋钮-11',
                        url: '/static/picture/A/button/fmPressButton_11.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-12',
                        url: '/static/picture/A/button/fmPressButton_12.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-13',
                        url: '/static/picture/A/button/fmPressButton_13.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-14',
                        url: '/static/picture/A/button/fmPressButton_14.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-15',
                        url: '/static/picture/A/button/fmPressButton_15.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-16',
                        url: '/static/picture/A/button/fmPressButton_16.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-17',
                        url: '/static/picture/A/button/fmPressButton_17.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-18',
                        url: '/static/picture/A/button/fmPressButton_18.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-19',
                        url: '/static/picture/A/button/fmPressButton_19.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ////
                    {
                        type: "img",
                        name: '按钮旋钮-20',
                        url: '/static/picture/A/button/fmpump (0).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-21',
                        url: '/static/picture/A/button/fmpump (1).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-22',
                        url: '/static/picture/A/button/fmpump (2).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-23',
                        url: '/static/picture/A/button/fmpump (3).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-24',
                        url: '/static/picture/A/button/fmpump (4).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-25',
                        url: '/static/picture/A/button/fmpump (5).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-26',
                        url: '/static/picture/A/button/fmpump (6).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-27',
                        url: '/static/picture/A/button/fmSelectorswitch_1.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-28',
                        url: '/static/picture/A/button/fmSelectorswitch_2.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-29',
                        url: '/static/picture/A/button/fmSelectorswitch_3.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-30',
                        url: '/static/picture/A/button/fmSelectorswitch_4.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-31',
                        url: '/static/picture/A/button/fmSelectorswitch_5.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-32',
                        url: '/static/picture/A/button/fmSelectorswitch_6.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-33',
                        url: '/static/picture/A/button/fmSelectorswitch_7.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-34',
                        url: '/static/picture/A/button/fmSelectorswitch_8.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-35',
                        url: '/static/picture/A/button/fmSelectorswitch_9.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-36',
                        url: '/static/picture/A/button/fmSelectorswitch_10.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ////////////
                    {
                        type: "img",
                        name: '按钮旋钮-37',
                        url: '/static/picture/A/button/fmSelectorswitch_11.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-38',
                        url: '/static/picture/A/button/fmSelectorswitch_12.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-39',
                        url: '/static/picture/A/button/fmSelectorswitch_13.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-40',
                        url: '/static/picture/A/button/fmSelectorswitch_14.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-41',
                        url: '/static/picture/A/button/fmSelectorswitch_15.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-42',
                        url: '/static/picture/A/button/fmSelectorswitch_16.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-43',
                        url: '/static/picture/A/button/fmSelectorswitch_17.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-44',
                        url: '/static/picture/A/button/fmSelectorswitch_18.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-45',
                        url: '/static/picture/A/button/fmSelectorswitch_19.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-46',
                        url: '/static/picture/A/button/fmSelectorswitch_20.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-47',
                        url: '/static/picture/A/button/fmSelectorswitch_21.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-48',
                        url: '/static/picture/A/button/fmSelectorswitch_22.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-49',
                        url: '/static/picture/A/button/fmSelectorswitch_23.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-50',
                        url: '/static/picture/A/button/fmSelectorswitch_24.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-51',
                        url: '/static/picture/A/button/fmSelectorswitch_25.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-52',
                        url: '/static/picture/A/button/fmSelectorswitch_26.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮旋钮-53',
                        url: '/static/picture/A/button/fmSelectorswitch_27.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    // {
                    // 	type: "img",
                    // 	name: '按钮旋钮-54',
                    // 	url: '/static/picture/A/togle/fmTogle11.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    //  },
                    //  {
                    // 	type: "img",
                    // 	name: '按钮旋钮-55',
                    // 	url: '/static/picture/A/togle/fmTogle12.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    //  },
                    //  {
                    // 	type: "img",
                    // 	name: '按钮旋钮-56',
                    // 	url: '/static/picture/A/togle/fmTogle21.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    //  },
                    //  {
                    // 	type: "img",
                    // 	name: '按钮旋钮-57',
                    // 	url: '/static/picture/A/togle/fmTogle22.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    //  },
                    //  {
                    // 	type: "img",
                    // 	name: '按钮旋钮-58',
                    // 	url: '/static/picture/A/togle/fmTogle31.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    //  },
                    //  {
                    // 	type: "img",
                    // 	name: '按钮旋钮-59',
                    // 	url: '/static/picture/A/togle/fmTogle32.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    //  },
                    //  {
                    // 	type: "img",
                    // 	name: '按钮旋钮-60',
                    // 	url: '/static/picture/A/togle/fmTogle41.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    //  },
                    //  {
                    // 	type: "img",
                    // 	name: '按钮旋钮-61',
                    // 	url: '/static/picture/A/togle/fmTogle42.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    //  },
                    //  {
                    // 	type: "img",
                    // 	name: '按钮旋钮-62',
                    // 	url: '/static/picture/A/togle/fmTogle51.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    //  },
                    //  {
                    // 	type: "img",
                    // 	name: '按钮旋钮-63',
                    // 	url: '/static/picture/A/togle/fmTogle52.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    //  },
                    //  {
                    // 	type: "img",
                    // 	name: '按钮旋钮-64',
                    // 	url: '/static/picture/A/togle/fmTogle61.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    //  },
                    //  {
                    // 	type: "img",
                    // 	name: '按钮旋钮-65',
                    // 	url: '/static/picture/A/togle/fmTogle62.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    //  },
                ]
            },
            {
                id0: 1, name: '泵', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '泵-1',
                        url: '/static/picture/A/pump/Pump07.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-2',
                        url: '/static/picture/A/pump/Pump08.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '泵-3',
                        url: '/static/picture/A/pump/Pump09.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-4',
                        url: '/static/picture/A/pump/Pump10.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    ///////
                    {
                        type: "img",
                        name: '泵-5',
                        url: '/static/picture/A/pump/Pump11.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-6',
                        url: '/static/picture/A/pump/Pump12.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '泵-7',
                        url: '/static/picture/A/pump/Pump13.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-8',
                        url: '/static/picture/A/pump/Pump14.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '泵-9',
                        url: '/static/picture/A/pump/Pump15.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-10',
                        url: '/static/picture/A/pump/Pump16.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '泵-11',
                        url: '/static/picture/A/pump/Pump17.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-12',
                        url: '/static/picture/A/pump/Pump18.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '泵-13',
                        url: '/static/picture/A/pump/Pump19.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-14',
                        url: '/static/picture/A/pump/Pump20.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '泵-15',
                        url: '/static/picture/A/pump/Pump21.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-16',
                        url: '/static/picture/A/pump/Pump22.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '泵-17',
                        url: '/static/picture/A/pump/Pump23.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-18',
                        url: '/static/picture/A/pump/Pump24.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    // {
                    // 	type: "img",
                    // 	name: '泵-1',
                    // 	url: '/static/picture/A/pump/fmpump0.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{  // 设置参数的类型  字符串 or 变量对象
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{  // 设置参数的实际数值
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [], // 绑定事件
                    // 	variableEvents: [], // 变量绑定事件
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '泵-2',
                    // 	url: '/static/picture/A/pump/fmpump1.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '泵-3',
                    // 	url: '/static/picture/A/pump/fmpump2.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{  // 设置参数的类型  字符串 or 变量对象
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{  // 设置参数的实际数值
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [], // 绑定事件
                    // 	variableEvents: [], // 变量绑定事件
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '泵-4',
                    // 	url: '/static/picture/A/pump/fmpump3.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '泵-5',
                    // 	url: '/static/picture/A/pump/fmpump4.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{  // 设置参数的类型  字符串 or 变量对象
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{  // 设置参数的实际数值
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [], // 绑定事件
                    // 	variableEvents: [], // 变量绑定事件
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '泵-6',
                    // 	url: '/static/picture/A/pump/fmpump5.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '泵-7',
                    // 	url: '/static/picture/A/pump/fmpump6.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{  // 设置参数的类型  字符串 or 变量对象
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{  // 设置参数的实际数值
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [], // 绑定事件
                    // 	variableEvents: [], // 变量绑定事件
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '泵-8',
                    // 	url: '/static/picture/A/pump/Pump01.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '泵-9',
                    // 	url: '/static/picture/A/pump/Pump02.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{  // 设置参数的类型  字符串 or 变量对象
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{  // 设置参数的实际数值
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [], // 绑定事件
                    // 	variableEvents: [], // 变量绑定事件
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '泵-10',
                    // 	url: '/static/picture/A/pump/Pump03.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '泵-11',
                    // 	url: '/static/picture/A/pump/Pump04.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{  // 设置参数的类型  字符串 or 变量对象
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{  // 设置参数的实际数值
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [], // 绑定事件
                    // 	variableEvents: [], // 变量绑定事件
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '泵-12',
                    // 	url: '/static/picture/A/pump/Pump05.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '泵-13',
                    // 	url: '/static/picture/A/pump/Pump06.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{  // 设置参数的类型  字符串 or 变量对象
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{  // 设置参数的实际数值
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [], // 绑定事件
                    // 	variableEvents: [], // 变量绑定事件
                    // },

                ]
            },
            {
                id0: 2, name: '阀', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '阀-1',
                        url: '/static/picture/A/valve/Valve01.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',
                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0,
                            state: true,

                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0,
                            state: true,

                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-2',
                        url: '/static/picture/A/valve/Valve02.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-3',
                        url: '/static/picture/A/valve/Valve03.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-4',
                        url: '/static/picture/A/valve/Valve04.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-5',
                        url: '/static/picture/A/valve/Valve05.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-6',
                        url: '/static/picture/A/valve/Valve06.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-7',
                        url: '/static/picture/A/valve/Valve07.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-8',
                        url: '/static/picture/A/valve/Valve08.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-9',
                        url: '/static/picture/A/valve/Valve09.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-10',
                        url: '/static/picture/A/valve/Valve10.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-11',
                        url: '/static/picture/A/valve/Valve11.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-12',
                        url: '/static/picture/A/valve/Valve12.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-13',
                        url: '/static/picture/A/valve/Valve13.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-14',
                        url: '/static/picture/A/valve/Valve14.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-15',
                        url: '/static/picture/A/valve/Valve15.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-16',
                        url: '/static/picture/A/valve/Map7.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-17',
                        url: '/static/picture/A/valve/Map8.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-18',
                        url: '/static/picture/A/valve/Map9.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-19',
                        url: '/static/picture/A/valve/Map10.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-20',
                        url: '/static/picture/A/valve/Map20.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-21',
                        url: '/static/picture/A/valve/Other04.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-22',
                        url: '/static/picture/A/valve/Other05.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    // {
                    // 	type: "img",
                    // 	name: '阀-16',
                    // 	url: '/static/picture/A/valve/fmvalve (0).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-17',
                    // 	url: '/static/picture/A/valve/fmvalve (1).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-18',
                    // 	url: '/static/picture/A/valve/fmvalve (2).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-19',
                    // 	url: '/static/picture/A/valve/fmvalve (3).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-20',
                    // 	url: '/static/picture/A/valve/fmvalve (4).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-21',
                    // 	url: '/static/picture/A/valve/fmvalve (5).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-22',
                    // 	url: '/static/picture/A/valve/fmvalve (6).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-23',
                    // 	url: '/static/picture/A/valve/fmvalve (7).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-24',
                    // 	url: '/static/picture/A/valve/fmvalve (8).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-25',
                    // 	url: '/static/picture/A/valve/fmvalve (9).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-26',
                    // 	url: '/static/picture/A/valve/fmvalve (10).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // ///////////
                    // {
                    // 	type: "img",
                    // 	name: '阀-27',
                    // 	url: '/static/picture/A/valve/fmvalve (11).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-28',
                    // 	url: '/static/picture/A/valve/fmvalve (12).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-29',
                    // 	url: '/static/picture/A/valve/fmvalve (13).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-30',
                    // 	url: '/static/picture/A/valve/fmvalve (14).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-31',
                    // 	url: '/static/picture/A/valve/fmvalve (15).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-32',
                    // 	url: '/static/picture/A/valve/fmvalve (16).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-33',
                    // 	url: '/static/picture/A/valve/fmvalve (17).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-34',
                    // 	url: '/static/picture/A/valve/fmvalve (18).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-35',
                    // 	url: '/static/picture/A/valve/fmvalve (19).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-36',
                    // 	url: '/static/picture/A/valve/fmvalve (20).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-37',
                    // 	url: '/static/picture/A/valve/fmvalve (21).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // ///////////
                    // {
                    // 	type: "img",
                    // 	name: '阀-38',
                    // 	url: '/static/picture/A/valve/fmvalve (22).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-39',
                    // 	url: '/static/picture/A/valve/fmvalve (23).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-40',
                    // 	url: '/static/picture/A/valve/fmvalve (24).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-41',
                    // 	url: '/static/picture/A/valve/fmvalve (25).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-42',
                    // 	url: '/static/picture/A/valve/fmvalve (26).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-43',
                    // 	url: '/static/picture/A/valve/fmvalve (27).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-44',
                    // 	url: '/static/picture/A/valve/fmvalve (28).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-45',
                    // 	url: '/static/picture/A/valve/fmvalve (29).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-46',
                    // 	url: '/static/picture/A/valve/fmvalve (30).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-47',
                    // 	url: '/static/picture/A/valve/fmvalve (31).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-48',
                    // 	url: '/static/picture/A/valve/fmvalve (32).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // ///////////
                    // {
                    // 	type: "img",
                    // 	name: '阀-49',
                    // 	url: '/static/picture/A/valve/fmvalve (33).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-50',
                    // 	url: '/static/picture/A/valve/fmvalve (34).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-51',
                    // 	url: '/static/picture/A/valve/fmvalve (35).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-52',
                    // 	url: '/static/picture/A/valve/fmvalve (36).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-53',
                    // 	url: '/static/picture/A/valve/fmvalve (37).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-54',
                    // 	url: '/static/picture/A/valve/fmvalve (38).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-55',
                    // 	url: '/static/picture/A/valve/fmvalve (39).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-56',
                    // 	url: '/static/picture/A/valve/fmvalve (40).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-57',
                    // 	url: '/static/picture/A/valve/fmvalve (41).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-58',
                    // 	url: '/static/picture/A/valve/fmvalve (42).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-59',
                    // 	url: '/static/picture/A/valve/fmvalve (43).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // ///////////
                    // {
                    // 	type: "img",
                    // 	name: '阀-60',
                    // 	url: '/static/picture/A/valve/fmvalve (44).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-61',
                    // 	url: '/static/picture/A/valve/fmvalve (45).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-62',
                    // 	url: '/static/picture/A/valve/fmvalve (46).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-63',
                    // 	url: '/static/picture/A/valve/fmvalve (47).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-64',
                    // 	url: '/static/picture/A/valve/fmvalve (48).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-65',
                    // 	url: '/static/picture/A/valve/fmvalve (49).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-66',
                    // 	url: '/static/picture/A/valve/fmvalve (50).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-67',
                    // 	url: '/static/picture/A/valve/fmvalve (51).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-68',
                    // 	url: '/static/picture/A/valve/fmvalve (52).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-69',
                    // 	url: '/static/picture/A/valve/fmvalve (53).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-70',
                    // 	url: '/static/picture/A/valve/fmvalve (54).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // ///////////
                    // {
                    // 	type: "img",
                    // 	name: '阀-71',
                    // 	url: '/static/picture/A/valve/fmvalve (55).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-72',
                    // 	url: '/static/picture/A/valve/fmvalve (56).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-73',
                    // 	url: '/static/picture/A/valve/fmvalve (57).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-74',
                    // 	url: '/static/picture/A/valve/fmvalve (58).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-75',
                    // 	url: '/static/picture/A/valve/fmvalve (59).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-76',
                    // 	url: '/static/picture/A/valve/fmvalve (60).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-77',
                    // 	url: '/static/picture/A/valve/fmvalve (61).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-78',
                    // 	url: '/static/picture/A/valve/fmvalve (62).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-79',
                    // 	url: '/static/picture/A/valve/fmvalve (63).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-80',
                    // 	url: '/static/picture/A/valve/fmvalve (64).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-81',
                    // 	url: '/static/picture/A/valve/fmvalve (65).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // ///////////
                    // {
                    // 	type: "img",
                    // 	name: '阀-82',
                    // 	url: '/static/picture/A/valve/fmvalve (66).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-83',
                    // 	url: '/static/picture/A/valve/fmvalve (67).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-84',
                    // 	url: '/static/picture/A/valve/fmvalve (68).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-85',
                    // 	url: '/static/picture/A/valve/fmvalve (69).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-86',
                    // 	url: '/static/picture/A/valve/fmvalve (70).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-87',
                    // 	url: '/static/picture/A/valve/fmvalve (71).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-88',
                    // 	url: '/static/picture/A/valve/fmvalve (72).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-89',
                    // 	url: '/static/picture/A/valve/fmvalve (73).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-90',
                    // 	url: '/static/picture/A/valve/fmvalve (74).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-91',
                    // 	url: '/static/picture/A/valve/fmvalve (75).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-92',
                    // 	url: '/static/picture/A/valve/fmvalve (76).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // ///////////
                    // {
                    // 	type: "img",
                    // 	name: '阀-93',
                    // 	url: '/static/picture/A/valve/fmvalve (77).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-94',
                    // 	url: '/static/picture/A/valve/fmvalve (78).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-95',
                    // 	url: '/static/picture/A/valve/fmvalve (79).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-96',
                    // 	url: '/static/picture/A/valve/fmvalve (80).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-97',
                    // 	url: '/static/picture/A/valve/fmvalve (81).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-98',
                    // 	url: '/static/picture/A/valve/fmvalve (82).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-99',
                    // 	url: '/static/picture/A/valve/fmvalve (83).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-100',
                    // 	url: '/static/picture/A/valve/fmvalve (84).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-101',
                    // 	url: '/static/picture/A/valve/fmvalve (85).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-102',
                    // 	url: '/static/picture/A/valve/fmvalve (86).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-103',
                    // 	url: '/static/picture/A/valve/fmvalve (87).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // ///////////
                    // {
                    // 	type: "img",
                    // 	name: '阀-104',
                    // 	url: '/static/picture/A/valve/fmvalve (88).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-105',
                    // 	url: '/static/picture/A/valve/fmvalve (89).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-106',
                    // 	url: '/static/picture/A/valve/fmvalve (90).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-107',
                    // 	url: '/static/picture/A/valve/fmvalve (91).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-108',
                    // 	url: '/static/picture/A/valve/fmvalve (92).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-109',
                    // 	url: '/static/picture/A/valve/fmvalve (93).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-110',
                    // 	url: '/static/picture/A/valve/fmvalve (94).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-111',
                    // 	url: '/static/picture/A/valve/fmvalve (95).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-112',
                    // 	url: '/static/picture/A/valve/fmvalve (96).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-113',
                    // 	url: '/static/picture/A/valve/fmvalve (97).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-114',
                    // 	url: '/static/picture/A/valve/fmvalve (98).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // ///////////
                    // {
                    // 	type: "img",
                    // 	name: '阀-115',
                    // 	url: '/static/picture/A/valve/fmvalve (99).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-116',
                    // 	url: '/static/picture/A/valve/fmvalve (100).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-117',
                    // 	url: '/static/picture/A/valve/fmvalve (101).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-118',
                    // 	url: '/static/picture/A/valve/fmvalve (102).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-119',
                    // 	url: '/static/picture/A/valve/fmvalve (103).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-120',
                    // 	url: '/static/picture/A/valve/fmvalve (104).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-121',
                    // 	url: '/static/picture/A/valve/fmvalve (105).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-122',
                    // 	url: '/static/picture/A/valve/fmvalve (106).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-123',
                    // 	url: '/static/picture/A/valve/fmvalve (107).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-124',
                    // 	url: '/static/picture/A/valve/fmvalve (108).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-125',
                    // 	url: '/static/picture/A/valve/fmvalve (109).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // ///////////
                    // {
                    // 	type: "img",
                    // 	name: '阀-126',
                    // 	url: '/static/picture/A/valve/fmvalve (110).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-127',
                    // 	url: '/static/picture/A/valve/fmvalve (111).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-128',
                    // 	url: '/static/picture/A/valve/fmvalve (112).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-129',
                    // 	url: '/static/picture/A/valve/fmvalve (113).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-130',
                    // 	url: '/static/picture/A/valve/fmvalve (114).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-131',
                    // 	url: '/static/picture/A/valve/fmvalve (115).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-132',
                    // 	url: '/static/picture/A/valve/fmvalve (116).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-133',
                    // 	url: '/static/picture/A/valve/fmvalve (117).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-134',
                    // 	url: '/static/picture/A/valve/fmvalve (118).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-135',
                    // 	url: '/static/picture/A/valve/fmvalve (119).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-136',
                    // 	url: '/static/picture/A/valve/fmvalve (120).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // ///////////
                    // {
                    // 	type: "img",
                    // 	name: '阀-137',
                    // 	url: '/static/picture/A/valve/fmvalve (121).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-138',
                    // 	url: '/static/picture/A/valve/fmvalve (122).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-139',
                    // 	url: '/static/picture/A/valve/fmvalve (123).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-140',
                    // 	url: '/static/picture/A/valve/fmvalve (124).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-141',
                    // 	url: '/static/picture/A/valve/fmvalve (125).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-142',
                    // 	url: '/static/picture/A/valve/fmvalve (126).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-143',
                    // 	url: '/static/picture/A/valve/fmvalve (127).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-144',
                    // 	url: '/static/picture/A/valve/fmvalve (128).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-134',
                    // 	url: '/static/picture/A/valve/fmvalve (129).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-145',
                    // 	url: '/static/picture/A/valve/fmvalve (130).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-146',
                    // 	url: '/static/picture/A/valve/fmvalve (131).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // ///////////
                    // {
                    // 	type: "img",
                    // 	name: '阀-147',
                    // 	url: '/static/picture/A/valve/fmvalve (132).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-148',
                    // 	url: '/static/picture/A/valve/fmvalve (133).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-149',
                    // 	url: '/static/picture/A/valve/fmvalve (134).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-150',
                    // 	url: '/static/picture/A/valve/fmvalve (135).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-151',
                    // 	url: '/static/picture/A/valve/fmvalve (136).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-152',
                    // 	url: '/static/picture/A/valve/fmvalve (137).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-153',
                    // 	url: '/static/picture/A/valve/fmvalve (138).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-154',
                    // 	url: '/static/picture/A/valve/fmvalve (139).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-155',
                    // 	url: '/static/picture/A/valve/fmvalve (140).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-156',
                    // 	url: '/static/picture/A/valve/fmvalve (141).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-157',
                    // 	url: '/static/picture/A/valve/fmvalve (142).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '阀-158',
                    // 	url: '/static/picture/A/valve/fmvalve (143).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                ]
            },
            {
                id0: 3, name: '马达', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '马达-1',
                        url: '/static/picture/A/motor/Motor01.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '马达-2',
                        url: '/static/picture/A/motor/Motor02.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '马达-3',
                        url: '/static/picture/A/motor/Motor03.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '马达-4',
                        url: '/static/picture/A/motor/Motor04.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '马达-5',
                        url: '/static/picture/A/motor/Motor06.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '马达-6',
                        url: '/static/picture/A/motor/Pump01.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '马达-7',
                        url: '/static/picture/A/motor/Pump02.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '马达-8',
                        url: '/static/picture/A/motor/Pump03.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '马达-9',
                        url: '/static/picture/A/motor/Pump04.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '马达-10',
                        url: '/static/picture/A/motor/Pump05.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '马达-11',
                        url: '/static/picture/A/motor/Pump06.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '马达-12',
                        url: '/static/picture/A/motor/Pump15.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '马达-13',
                        url: '/static/picture/A/motor/Pump16.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '马达-14',
                        url: '/static/picture/A/motor/Pump17.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    {
                        type: "img",
                        name: '马达-15',
                        url: '/static/picture/A/motor/Pump18.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {  // 设置参数的类型  字符串 or 变量对象
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {  // 设置参数的实际数值
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [], // 绑定事件
                        variableEvents: [], // 变量绑定事件
                    },
                    ////////
                    // {
                    // 		type: "img",
                    // 		name: '发动机-1',
                    // 		url: '/static/picture/A/motor/fmmotor (0).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-2',
                    // 		url: '/static/picture/A/motor/fmmotor (1).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-3',
                    // 		url: '/static/picture/A/motor/fmmotor (2).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-4',
                    // 		url: '/static/picture/A/motor/fmmotor (3).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-5',
                    // 		url: '/static/picture/A/motor/fmmotor (4).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-6',
                    // 		url: '/static/picture/A/motor/fmmotor (5).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-7',
                    // 		url: '/static/picture/A/motor/fmmotor (6).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-8',
                    // 		url: '/static/picture/A/motor/fmmotor (7).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-9',
                    // 		url: '/static/picture/A/motor/fmmotor (8).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-10',
                    // 		url: '/static/picture/A/motor/fmmotor (9).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-11',
                    // 		url: '/static/picture/A/motor/fmmotor (10).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-12',
                    // 		url: '/static/picture/A/motor/fmmotor (11).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-13',
                    // 		url: '/static/picture/A/motor/fmmotor (12).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-14',
                    // 		url: '/static/picture/A/motor/fmmotor (13).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-15',
                    // 		url: '/static/picture/A/motor/fmmotor (14).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 ///////////
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-16',
                    // 		url: '/static/picture/A/motor/fmmotor (15).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-17',
                    // 		url: '/static/picture/A/motor/fmmotor (16).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-18',
                    // 		url: '/static/picture/A/motor/fmmotor (17).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-19',
                    // 		url: '/static/picture/A/motor/fmmotor (18).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-20',
                    // 		url: '/static/picture/A/motor/fmmotor (19).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-21',
                    // 		url: '/static/picture/A/motor/fmmotor (20).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-22',
                    // 		url: '/static/picture/A/motor/fmmotor (21).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-23',
                    // 		url: '/static/picture/A/motor/fmmotor (22).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-24',
                    // 		url: '/static/picture/A/motor/fmmotor (23).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-25',
                    // 		url: '/static/picture/A/motor/fmmotor (24).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-26',
                    // 		url: '/static/picture/A/motor/fmmotor (25).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 ///////////
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-27',
                    // 		url: '/static/picture/A/motor/fmmotor (26).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-28',
                    // 		url: '/static/picture/A/motor/fmmotor (27).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-29',
                    // 		url: '/static/picture/A/motor/fmmotor (28).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-30',
                    // 		url: '/static/picture/A/motor/fmmotor (29).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-31',
                    // 		url: '/static/picture/A/motor/fmmotor (30).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-32',
                    // 		url: '/static/picture/A/motor/fmmotor (31).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-33',
                    // 		url: '/static/picture/A/motor/fmmotor (32).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-34',
                    // 		url: '/static/picture/A/motor/fmmotor (33).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-35',
                    // 		url: '/static/picture/A/motor/fmmotor (34).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-36',
                    // 		url: '/static/picture/A/motor/fmmotor (35).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-37',
                    // 		url: '/static/picture/A/motor/fmmotor (36).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 ///////////
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-38',
                    // 		url: '/static/picture/A/motor/fmmotor (37).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-39',
                    // 		url: '/static/picture/A/motor/fmmotor (38).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-40',
                    // 		url: '/static/picture/A/motor/fmmotor (39).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-41',
                    // 		url: '/static/picture/A/motor/fmmotor (40).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-42',
                    // 		url: '/static/picture/A/motor/fmmotor (41).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-43',
                    // 		url: '/static/picture/A/motor/fmmotor (42).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-44',
                    // 		url: '/static/picture/A/motor/fmmotor (43).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-45',
                    // 		url: '/static/picture/A/motor/fmmotor (44).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-46',
                    // 		url: '/static/picture/A/motor/fmmotor (45).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-47',
                    // 		url: '/static/picture/A/motor/fmmotor (46).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-48',
                    // 		url: '/static/picture/A/motor/fmmotor (47).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 ///////////
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-49',
                    // 		url: '/static/picture/A/motor/fmmotor (48).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-50',
                    // 		url: '/static/picture/A/motor/fmmotor (49).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-51',
                    // 		url: '/static/picture/A/motor/fmmotor (50).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-52',
                    // 		url: '/static/picture/A/motor/fmmotor (51).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-53',
                    // 		url: '/static/picture/A/motor/fmmotor (52).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 		type: "img",
                    // 		name: '发动机-54',
                    // 		url: '/static/picture/A/motor/fmmotor (53).bmp',
                    // 		wrapperStyle:{
                    // 			width:'100px',
                    // 			height:'100px',
                    // 		},
                    // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 		},
                    // 		settings:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		realtimeData:{
                    // 			width:'100',
                    // 			height:'100',
                    // 			imgName: '图片',
                    // 			imgDirection: 0,state:true,
                    // 		},
                    // 		events: [],
                    // 		variableEvents: [],
                    // 	 },
                    // 	 {
                    // 	 	type: "img",
                    // 	 	name: '发动机-55',
                    // 	 	url: '/static/picture/A/motor/Motor01.bmp',
                    // 	 	wrapperStyle:{
                    // 	 		width:'100px',
                    // 	 		height:'100px',
                    // 	 	},
                    // 	 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	 	},
                    // 	 	settings:{
                    // 	 		width:'100',
                    // 	 		height:'100',
                    // 	 		imgName: '图片',
                    // 	 		imgDirection: 0,state:true,
                    // 	 	},
                    // 	 	realtimeData:{
                    // 	 		width:'100',
                    // 	 		height:'100',
                    // 	 		imgName: '图片',
                    // 	 		imgDirection: 0,state:true,
                    // 	 	},
                    // 	 	events: [],
                    // 	 	variableEvents: [],
                    // 	 },
                    // 	 {
                    // 	 	type: "img",
                    // 	 	name: '发动机-56',
                    // 	 	url: '/static/picture/A/motor/Motor02.bmp',
                    // 	 	wrapperStyle:{
                    // 	 		width:'100px',
                    // 	 		height:'100px',
                    // 	 	},
                    // 	 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	 	},
                    // 	 	settings:{  // 设置参数的类型  字符串 or 变量对象
                    // 	 		width:'100',
                    // 	 		height:'100',
                    // 	 		imgName: '图片',
                    // 	 		imgDirection: 0,state:true,
                    // 	 	},
                    // 	 	realtimeData:{  // 设置参数的实际数值
                    // 	 		width:'100',
                    // 	 		height:'100',
                    // 	 		imgName: '图片',
                    // 	 		imgDirection: 0,state:true,
                    // 	 	},
                    // 	 	events: [], // 绑定事件
                    // 	 	variableEvents: [], // 变量绑定事件
                    // 	 },
                    // 	 {
                    // 	 	type: "img",
                    // 	 	name: '发动机-57',
                    // 	 	url: '/static/picture/A/motor/Motor03.bmp',
                    // 	 	wrapperStyle:{
                    // 	 		width:'100px',
                    // 	 		height:'100px',
                    // 	 	},
                    // 	 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	 	},
                    // 	 	settings:{
                    // 	 		width:'100',
                    // 	 		height:'100',
                    // 	 		imgName: '图片',
                    // 	 		imgDirection: 0,state:true,
                    // 	 	},
                    // 	 	realtimeData:{
                    // 	 		width:'100',
                    // 	 		height:'100',
                    // 	 		imgName: '图片',
                    // 	 		imgDirection: 0,state:true,
                    // 	 	},
                    // 	 	events: [],
                    // 	 	variableEvents: [],
                    // 	 },
                    // 	 {
                    // 	 	type: "img",
                    // 	 	name: '发动机-58',
                    // 	 	url: '/static/picture/A/motor/Motor04.bmp',
                    // 	 	wrapperStyle:{
                    // 	 		width:'100px',
                    // 	 		height:'100px',
                    // 	 	},
                    // 	 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	 	},
                    // 	 	settings:{  // 设置参数的类型  字符串 or 变量对象
                    // 	 		width:'100',
                    // 	 		height:'100',
                    // 	 		imgName: '图片',
                    // 	 		imgDirection: 0,state:true,
                    // 	 	},
                    // 	 	realtimeData:{  // 设置参数的实际数值
                    // 	 		width:'100',
                    // 	 		height:'100',
                    // 	 		imgName: '图片',
                    // 	 		imgDirection: 0,state:true,
                    // 	 	},
                    // 	 	events: [], // 绑定事件
                    // 	 	variableEvents: [], // 变量绑定事件
                    // 	 },
                    // 	 {
                    // 	 	type: "img",
                    // 	 	name: '发动机-59',
                    // 	 	url: '/static/picture/A/motor/Motor05.bmp',
                    // 	 	wrapperStyle:{
                    // 	 		width:'100px',
                    // 	 		height:'100px',
                    // 	 	},
                    // 	 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	 	},
                    // 	 	settings:{
                    // 	 		width:'100',
                    // 	 		height:'100',
                    // 	 		imgName: '图片',
                    // 	 		imgDirection: 0,state:true,
                    // 	 	},
                    // 	 	realtimeData:{
                    // 	 		width:'100',
                    // 	 		height:'100',
                    // 	 		imgName: '图片',
                    // 	 		imgDirection: 0,state:true,
                    // 	 	},
                    // 	 	events: [],
                    // 	 	variableEvents: [],
                    // 	 },
                    // 	 {
                    // 	 	type: "img",
                    // 	 	name: '发动机-60',
                    // 	 	url: '/static/picture/A/motor/Motor06.bmp',
                    // 	 	wrapperStyle:{
                    // 	 		width:'100px',
                    // 	 		height:'100px',
                    // 	 	},
                    // 	 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	 	},
                    // 	 	settings:{  // 设置参数的类型  字符串 or 变量对象
                    // 	 		width:'100',
                    // 	 		height:'100',
                    // 	 		imgName: '图片',
                    // 	 		imgDirection: 0,state:true,
                    // 	 	},
                    // 	 	realtimeData:{  // 设置参数的实际数值
                    // 	 		width:'100',
                    // 	 		height:'100',
                    // 	 		imgName: '图片',
                    // 	 		imgDirection: 0,state:true,
                    // 	 	},
                    // 	 	events: [], // 绑定事件
                    // 	 	variableEvents: [], // 变量绑定事件
                    // 	 },

                ]
            },
            {
                id0: 4, name: '罐', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '罐-1',
                        url: '/static/picture/A/tank/fmtank (0).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-2',
                        url: '/static/picture/A/tank/fmtank (1).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-3',
                        url: '/static/picture/A/tank/fmtank (2).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-4',
                        url: '/static/picture/A/tank/fmtank (3).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    // {
                    // type: "img",
                    // name: '罐-5',
                    // url: '/static/picture/A/tank/fmtank (4).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    {
                        type: "img",
                        name: '罐-5',
                        url: '/static/picture/A/tank/fmtank (5).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-6',
                        url: '/static/picture/A/tank/fmtank (6).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    // {
                    // type: "img",
                    // name: '罐-8',
                    // url: '/static/picture/A/tank/fmtank (7).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-9',
                    // url: '/static/picture/A/tank/fmtank (8).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-10',
                    // url: '/static/picture/A/tank/fmtank (9).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-11',
                    // url: '/static/picture/A/tank/fmtank (10).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-12',
                    // url: '/static/picture/A/tank/fmtank (11).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-13',
                    // url: '/static/picture/A/tank/fmtank (12).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-14',
                    // url: '/static/picture/A/tank/fmtank (13).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-15',
                    // url: '/static/picture/A/tank/fmtank (14).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // ///////////
                    // {
                    // type: "img",
                    // name: '罐-16',
                    // url: '/static/picture/A/tank/fmtank (15).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-17',
                    // url: '/static/picture/A/tank/fmtank (16).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-18',
                    // url: '/static/picture/A/tank/fmtank (17).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-19',
                    // url: '/static/picture/A/tank/fmtank (18).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    {
                        type: "img",
                        name: '罐-7',
                        url: '/static/picture/A/tank/fmtank (19).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-8',
                        url: '/static/picture/A/tank/fmtank (20).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-9',
                        url: '/static/picture/A/tank/fmtank (21).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    // {
                    // type: "img",
                    // name: '罐-23',
                    // url: '/static/picture/A/tank/fmtank (22).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-24',
                    // url: '/static/picture/A/tank/fmtank (23).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    {
                        type: "img",
                        name: '罐-10',
                        url: '/static/picture/A/tank/fmtank (24).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-11',
                        url: '/static/picture/A/tank/fmtank (25).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '罐-12',
                        url: '/static/picture/A/tank/fmtank (26).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-13',
                        url: '/static/picture/A/tank/fmtank (27).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-14',
                        url: '/static/picture/A/tank/fmtank (28).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-15',
                        url: '/static/picture/A/tank/fmtank (29).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-16',
                        url: '/static/picture/A/tank/fmtank (30).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-17',
                        url: '/static/picture/A/tank/fmtank (31).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-18',
                        url: '/static/picture/A/tank/fmtank (32).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-19',
                        url: '/static/picture/A/tank/fmtank (33).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-20',
                        url: '/static/picture/A/tank/fmtank (34).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    // {
                    // type: "img",
                    // name: '罐-36',
                    // url: '/static/picture/A/tank/fmtank (35).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-37',
                    // url: '/static/picture/A/tank/fmtank (36).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // ///////////
                    // {
                    // type: "img",
                    // name: '罐-38',
                    // url: '/static/picture/A/tank/fmtank (37).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-39',
                    // url: '/static/picture/A/tank/fmtank (38).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-40',
                    // url: '/static/picture/A/tank/fmtank (39).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-41',
                    // url: '/static/picture/A/tank/fmtank (40).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-42',
                    // url: '/static/picture/A/tank/fmtank (41).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-43',
                    // url: '/static/picture/A/tank/fmtank (42).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    {
                        type: "img",
                        name: '罐-21',
                        url: '/static/picture/A/tank/fmtank (43).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    // {
                    // type: "img",
                    // name: '罐-45',
                    // url: '/static/picture/A/tank/fmtank (44).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-46',
                    // url: '/static/picture/A/tank/fmtank (45).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-47',
                    // url: '/static/picture/A/tank/fmtank (46).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-48',
                    // url: '/static/picture/A/tank/fmtank (47).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // ///////////
                    // {
                    // type: "img",
                    // name: '罐-49',
                    // url: '/static/picture/A/tank/fmtank (48).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-50',
                    // url: '/static/picture/A/tank/fmtank (49).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-51',
                    // url: '/static/picture/A/tank/fmtank (50).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-52',
                    // url: '/static/picture/A/tank/fmtank (51).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-53',
                    // url: '/static/picture/A/tank/fmtank (52).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // type: "img",
                    // name: '罐-54',
                    // url: '/static/picture/A/tank/fmtank (53).bmp',
                    // wrapperStyle:{
                    // 	width:'100px',
                    // 	height:'100px',
                    // },
                    // style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // },
                    // settings:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // realtimeData:{
                    // 	width:'100',
                    // 	height:'100',
                    // 	imgName: '图片',
                    // 	imgDirection: 0,state:true,
                    // },
                    // events: [],
                    // variableEvents: [],
                    // },
                    // {
                    // 					 	type: "img",
                    // 					 	name: '罐-55',
                    // 					 	url: '/static/picture/A/tank/fmtank (54).bmp',
                    // 					 	wrapperStyle:{
                    // 					 		width:'100px',
                    // 					 		height:'100px',
                    // 					 	},
                    // 					 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 					 	},
                    // 					 	settings:{
                    // 					 		width:'100',
                    // 					 		height:'100',
                    // 					 		imgName: '图片',
                    // 					 		imgDirection: 0,state:true,
                    // 					 	},
                    // 					 	realtimeData:{
                    // 					 		width:'100',
                    // 					 		height:'100',
                    // 					 		imgName: '图片',
                    // 					 		imgDirection: 0,state:true,
                    // 					 	},
                    // 					 	events: [],
                    // 					 	variableEvents: [],
                    // 					 },
                    // 					 {
                    // 					 	type: "img",
                    // 					 	name: '罐-56',
                    // 					 	url: '/static/picture/A/tank/fmtank (55).bmp',
                    // 					 	wrapperStyle:{
                    // 					 		width:'100px',
                    // 					 		height:'100px',
                    // 					 	},
                    // 					 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 					 	},
                    // 					 	settings:{
                    // 					 		width:'100',
                    // 					 		height:'100',
                    // 					 		imgName: '图片',
                    // 					 		imgDirection: 0,state:true,
                    // 					 	},
                    // 					 	realtimeData:{
                    // 					 		width:'100',
                    // 					 		height:'100',
                    // 					 		imgName: '图片',
                    // 					 		imgDirection: 0,state:true,
                    // 					 	},
                    // 					 	events: [],
                    // 					 	variableEvents: [],
                    // 					 },
                    // 					 {
                    // 					 	type: "img",
                    // 					 	name: '罐-57',
                    // 					 	url: '/static/picture/A/tank/fmtank (56).bmp',
                    // 					 	wrapperStyle:{
                    // 					 		width:'100px',
                    // 					 		height:'100px',
                    // 					 	},
                    // 					 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 					 	},
                    // 					 	settings:{
                    // 					 		width:'100',
                    // 					 		height:'100',
                    // 					 		imgName: '图片',
                    // 					 		imgDirection: 0,state:true,
                    // 					 	},
                    // 					 	realtimeData:{
                    // 					 		width:'100',
                    // 					 		height:'100',
                    // 					 		imgName: '图片',
                    // 					 		imgDirection: 0,state:true,
                    // 					 	},
                    // 					 	events: [],
                    // 					 	variableEvents: [],
                    // 					 },
                    // 					 {
                    // 					 	type: "img",
                    // 					 	name: '罐-58',
                    // 					 	url: '/static/picture/A/tank/fmtank (57).bmp',
                    // 					 	wrapperStyle:{
                    // 					 		width:'100px',
                    // 					 		height:'100px',
                    // 					 	},
                    // 					 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 					 	},
                    // 					 	settings:{
                    // 					 		width:'100',
                    // 					 		height:'100',
                    // 					 		imgName: '图片',
                    // 					 		imgDirection: 0,state:true,
                    // 					 	},
                    // 					 	realtimeData:{
                    // 					 		width:'100',
                    // 					 		height:'100',
                    // 					 		imgName: '图片',
                    // 					 		imgDirection: 0,state:true,
                    // 					 	},
                    // 					 	events: [],
                    // 					 	variableEvents: [],
                    // 					 },
                    // 					 {
                    // 					 	type: "img",
                    // 					 	name: '罐-59',
                    // 					 	url: '/static/picture/A/tank/fmtank (58).bmp',
                    // 					 	wrapperStyle:{
                    // 					 		width:'100px',
                    // 					 		height:'100px',
                    // 					 	},
                    // 					 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 					 	},
                    // 					 	settings:{
                    // 					 		width:'100',
                    // 					 		height:'100',
                    // 					 		imgName: '图片',
                    // 					 		imgDirection: 0,state:true,
                    // 					 	},
                    // 					 	realtimeData:{
                    // 					 		width:'100',
                    // 					 		height:'100',
                    // 					 		imgName: '图片',
                    // 					 		imgDirection: 0,state:true,
                    // 					 	},
                    // 					 	events: [],
                    // 					 	variableEvents: [],
                    // 					 },
                    // 					 ///////////
                    // 					 {
                    // 					 	type: "img",
                    // 					 	name: '罐-60',
                    // 					 	url: '/static/picture/A/tank/fmtank (59).bmp',
                    // 					 	wrapperStyle:{
                    // 					 		width:'100px',
                    // 					 		height:'100px',
                    // 					 	},
                    // 					 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 					 	},
                    // 					 	settings:{
                    // 					 		width:'100',
                    // 					 		height:'100',
                    // 					 		imgName: '图片',
                    // 					 		imgDirection: 0,state:true,
                    // 					 	},
                    // 					 	realtimeData:{
                    // 					 		width:'100',
                    // 					 		height:'100',
                    // 					 		imgName: '图片',
                    // 					 		imgDirection: 0,state:true,
                    // 					 	},
                    // 					 	events: [],
                    // 					 	variableEvents: [],
                    // 					 },
                    {
                        type: "img",
                        name: '罐-22',
                        url: '/static/picture/A/tank/fmtank (60).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    // {
                    // 	type: "img",
                    // 	name: '罐-62',
                    // 	url: '/static/picture/A/tank/fmtank (61).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    {
                        type: "img",
                        name: '罐-23',
                        url: '/static/picture/A/tank/fmtank (62).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-24',
                        url: '/static/picture/A/tank/fmtank (63).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-25',
                        url: '/static/picture/A/tank/fmtank (64).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    // {
                    // 	type: "img",
                    // 	name: '罐-66',
                    // 	url: '/static/picture/A/tank/fmtank (65).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '罐-67',
                    // 	url: '/static/picture/A/tank/fmtank (66).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '罐-68',
                    // 	url: '/static/picture/A/tank/fmtank (67).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '罐-69',
                    // 	url: '/static/picture/A/tank/fmtank (68).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '罐-70',
                    // 	url: '/static/picture/A/tank/fmtank (69).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // ///////////
                    // {
                    // 	type: "img",
                    // 	name: '罐-71',
                    // 	url: '/static/picture/A/tank/fmtank (70).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    {
                        type: "img",
                        name: '罐-26',
                        url: '/static/picture/A/tank/fmtank (71).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-27',
                        url: '/static/picture/A/tank/fmtank (72).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    // {
                    // 	type: "img",
                    // 	name: '罐-74',
                    // 	url: '/static/picture/A/tank/fmtank (73).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '罐-75',
                    // 	url: '/static/picture/A/tank/fmtank (74).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '罐-76',
                    // 	url: '/static/picture/A/tank/fmtank (75).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    {
                        type: "img",
                        name: '罐-28',
                        url: '/static/picture/A/tank/fmtank (76).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    // {
                    // 	type: "img",
                    // 	name: '罐-78',
                    // 	url: '/static/picture/A/tank/fmtank (77).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '罐-79',
                    // 	url: '/static/picture/A/tank/fmtank (78).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '罐-80',
                    // 	url: '/static/picture/A/tank/fmtank (79).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    {
                        type: "img",
                        name: '罐-29',
                        url: '/static/picture/A/tank/fmtank (80).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    // {
                    // 	type: "img",
                    // 	name: '罐-82',
                    // 	url: '/static/picture/A/tank/fmtank (81).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '罐-83',
                    // 	url: '/static/picture/A/tank/fmtank (82).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    {
                        type: "img",
                        name: '罐-30',
                        url: '/static/picture/A/tank/fmtank (83).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    // {
                    // 	type: "img",
                    // 	name: '罐-85',
                    // 	url: '/static/picture/A/tank/fmtank (84).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '罐-86',
                    // 	url: '/static/picture/A/tank/fmtank (85).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    {
                        type: "img",
                        name: '罐-31',
                        url: '/static/picture/A/tank/fmtank (86).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-32',
                        url: '/static/picture/A/tank/fmtank (87).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-33',
                        url: '/static/picture/A/tank/fmtank (88).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    // {
                    // 	type: "img",
                    // 	name: '罐-90',
                    // 	url: '/static/picture/A/tank/fmtank (89).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    {
                        type: "img",
                        name: '罐-34',
                        url: '/static/picture/A/tank/fmtank (90).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    //  {
                    //  	type: "img",
                    //  	name: '罐-35',
                    //  	url: '/static/picture/A/tank/fmtank (91).bmp',
                    //  	wrapperStyle:{
                    //  		width:'100px',
                    //  		height:'100px',
                    //  	},
                    //  	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    //  	},
                    //  	settings:{
                    //  		width:'100',
                    //  		height:'100',
                    //  		imgName: '图片',
                    //  		imgDirection: 0,state:true,
                    //  	},
                    //  	realtimeData:{
                    //  		width:'100',
                    //  		height:'100',
                    //  		imgName: '图片',
                    //  		imgDirection: 0,state:true,
                    //  	},
                    //  	events: [],
                    //  	variableEvents: [],
                    //  },
                    //  ///////////
                    //  {
                    //  	type: "img",
                    //  	name: '罐-36',
                    //  	url: '/static/picture/A/tank/fmtank (92).bmp',
                    //  	wrapperStyle:{
                    //  		width:'100px',
                    //  		height:'100px',
                    //  	},
                    //  	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    //  	},
                    //  	settings:{
                    //  		width:'100',
                    //  		height:'100',
                    //  		imgName: '图片',
                    //  		imgDirection: 0,state:true,
                    //  	},
                    //  	realtimeData:{
                    //  		width:'100',
                    //  		height:'100',
                    //  		imgName: '图片',
                    //  		imgDirection: 0,state:true,
                    //  	},
                    //  	events: [],
                    //  	variableEvents: [],
                    //  },
                    // {
                    // 	type: "img",
                    // 	name: '罐-37',
                    // 	url: '/static/picture/A/tank/fmtank (93).bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    // {
                    // 	type: "img",
                    // 	name: '罐-38',
                    // 	url: '/static/picture/A/tank/.bmp',
                    // 	wrapperStyle:{
                    // 		width:'100px',
                    // 		height:'100px',
                    // 	},
                    // 	style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

                    // 	},
                    // 	settings:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	realtimeData:{
                    // 		width:'100',
                    // 		height:'100',
                    // 		imgName: '图片',
                    // 		imgDirection: 0,state:true,
                    // 	},
                    // 	events: [],
                    // 	variableEvents: [],
                    // },
                    {
                        type: "img",
                        name: '罐-35',
                        url: '/static/picture/A/tank/Map1.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-36',
                        url: '/static/picture/A/tank/Map2.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-37',
                        url: '/static/picture/A/tank/Map3.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-38',
                        url: '/static/picture/A/tank/Map5.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-39',
                        url: '/static/picture/A/tank/Map6.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-40',
                        url: '/static/picture/A/tank/Motor05.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐-41',
                        url: '/static/picture/A/tank/Other01.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },


                ]
            },
            // {id0:5,name:'箭头',showPicture: false,
            // pictureList:[
            // 	{
            // 				type: "img",
            // 				name: '箭头-1',
            // 				url: '/static/picture/A/arrow/fmarrow (0).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-2',
            // 				url: '/static/picture/A/arrow/fmarrow (1).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-3',
            // 				url: '/static/picture/A/arrow/fmarrow (2).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-4',
            // 				url: '/static/picture/A/arrow/fmarrow (3).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-5',
            // 				url: '/static/picture/A/arrow/fmarrow (4).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-6',
            // 				url: '/static/picture/A/arrow/fmarrow (5).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-7',
            // 				url: '/static/picture/A/arrow/fmarrow (6).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-8',
            // 				url: '/static/picture/A/arrow/fmarrow (7).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-9',
            // 				url: '/static/picture/A/arrow/fmarrow (8).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-10',
            // 				url: '/static/picture/A/arrow/fmarrow (9).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-11',
            // 				url: '/static/picture/A/arrow/fmarrow (10).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-12',
            // 				url: '/static/picture/A/arrow/fmarrow (11).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-13',
            // 				url: '/static/picture/A/arrow/fmarrow (12).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-14',
            // 				url: '/static/picture/A/arrow/fmarrow (13).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-15',
            // 				url: '/static/picture/A/arrow/fmarrow (14).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 ///////////
            // 			 {
            // 				type: "img",
            // 				name: '箭头-16',
            // 				url: '/static/picture/A/arrow/fmarrow (15).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-17',
            // 				url: '/static/picture/A/arrow/fmarrow (16).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-18',
            // 				url: '/static/picture/A/arrow/fmarrow (17).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-19',
            // 				url: '/static/picture/A/arrow/fmarrow (18).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-20',
            // 				url: '/static/picture/A/arrow/fmarrow (19).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-21',
            // 				url: '/static/picture/A/arrow/fmarrow (20).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-22',
            // 				url: '/static/picture/A/arrow/fmarrow (21).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-23',
            // 				url: '/static/picture/A/arrow/fmarrow (22).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-24',
            // 				url: '/static/picture/A/arrow/fmarrow (23).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-25',
            // 				url: '/static/picture/A/arrow/fmarrow (24).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-26',
            // 				url: '/static/picture/A/arrow/fmarrow (25).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 ///////////
            // 			 {
            // 				type: "img",
            // 				name: '箭头-27',
            // 				url: '/static/picture/A/arrow/fmarrow (26).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-28',
            // 				url: '/static/picture/A/arrow/fmarrow (27).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-29',
            // 				url: '/static/picture/A/arrow/fmarrow (28).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-30',
            // 				url: '/static/picture/A/arrow/fmarrow (29).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-31',
            // 				url: '/static/picture/A/arrow/fmarrow (30).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-32',
            // 				url: '/static/picture/A/arrow/fmarrow (31).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-33',
            // 				url: '/static/picture/A/arrow/fmarrow (32).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-34',
            // 				url: '/static/picture/A/arrow/fmarrow (33).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-35',
            // 				url: '/static/picture/A/arrow/fmarrow (34).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-36',
            // 				url: '/static/picture/A/arrow/fmarrow (35).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-37',
            // 				url: '/static/picture/A/arrow/fmarrow (36).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 ///////////
            // 			 {
            // 				type: "img",
            // 				name: '箭头-38',
            // 				url: '/static/picture/A/arrow/fmarrow (37).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-39',
            // 				url: '/static/picture/A/arrow/fmarrow (38).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-40',
            // 				url: '/static/picture/A/arrow/fmarrow (39).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-41',
            // 				url: '/static/picture/A/arrow/fmarrow (40).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-42',
            // 				url: '/static/picture/A/arrow/fmarrow (41).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-43',
            // 				url: '/static/picture/A/arrow/fmarrow (42).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-44',
            // 				url: '/static/picture/A/arrow/fmarrow (43).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-45',
            // 				url: '/static/picture/A/arrow/fmarrow (44).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-46',
            // 				url: '/static/picture/A/arrow/fmarrow (45).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-47',
            // 				url: '/static/picture/A/arrow/fmarrow (46).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-48',
            // 				url: '/static/picture/A/arrow/fmarrow (47).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 ///////////
            // 			 {
            // 				type: "img",
            // 				name: '箭头-49',
            // 				url: '/static/picture/A/arrow/fmarrow (48).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-50',
            // 				url: '/static/picture/A/arrow/fmarrow (49).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-51',
            // 				url: '/static/picture/A/arrow/fmarrow (50).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-52',
            // 				url: '/static/picture/A/arrow/fmarrow (51).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-53',
            // 				url: '/static/picture/A/arrow/fmarrow (52).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 			 {
            // 				type: "img",
            // 				name: '箭头-54',
            // 				url: '/static/picture/A/arrow/fmarrow (53).bmp',
            // 				wrapperStyle:{
            // 					width:'100px',
            // 					height:'100px',
            // 				},
            // 				style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 				},
            // 				settings:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				realtimeData:{
            // 					width:'100',
            // 					height:'100',
            // 					imgName: '图片',
            // 					imgDirection: 0,state:true,
            // 				},
            // 				events: [],
            // 				variableEvents: [],
            // 			 },
            // 		{
            // 			type: "img",
            // 			name: '箭头-55',
            // 			url: '/static/picture/A/arrow/fmarrow (54).bmp',
            // 			wrapperStyle:{
            // 				width:'100px',
            // 				height:'100px',
            // 			},
            // 			style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 			},
            // 			settings:{
            // 				width:'100',
            // 				height:'100',
            // 				imgName: '图片',
            // 				imgDirection: 0,state:true,
            // 			},
            // 			realtimeData:{
            // 				width:'100',
            // 				height:'100',
            // 				imgName: '图片',
            // 				imgDirection: 0,state:true,
            // 			},
            // 			events: [],
            // 			variableEvents: [],
            // 		 },
            // 		 {
            // 			type: "img",
            // 			name: '箭头-56',
            // 			url: '/static/picture/A/arrow/fmarrow (55).bmp',
            // 			wrapperStyle:{
            // 				width:'100px',
            // 				height:'100px',
            // 			},
            // 			style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 			},
            // 			settings:{
            // 				width:'100',
            // 				height:'100',
            // 				imgName: '图片',
            // 				imgDirection: 0,state:true,
            // 			},
            // 			realtimeData:{
            // 				width:'100',
            // 				height:'100',
            // 				imgName: '图片',
            // 				imgDirection: 0,state:true,
            // 			},
            // 			events: [],
            // 			variableEvents: [],
            // 		 },
            // 		 {
            // 			type: "img",
            // 			name: '箭头-57',
            // 			url: '/static/picture/A/arrow/fmarrow (56).bmp',
            // 			wrapperStyle:{
            // 				width:'100px',
            // 				height:'100px',
            // 			},
            // 			style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 			},
            // 			settings:{
            // 				width:'100',
            // 				height:'100',
            // 				imgName: '图片',
            // 				imgDirection: 0,state:true,
            // 			},
            // 			realtimeData:{
            // 				width:'100',
            // 				height:'100',
            // 				imgName: '图片',
            // 				imgDirection: 0,state:true,
            // 			},
            // 			events: [],
            // 			variableEvents: [],
            // 		 },
            // 		 {
            // 			type: "img",
            // 			name: '箭头-58',
            // 			url: '/static/picture/A/arrow/fmarrow (57).bmp',
            // 			wrapperStyle:{
            // 				width:'100px',
            // 				height:'100px',
            // 			},
            // 			style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 			},
            // 			settings:{
            // 				width:'100',
            // 				height:'100',
            // 				imgName: '图片',
            // 				imgDirection: 0,state:true,
            // 			},
            // 			realtimeData:{
            // 				width:'100',
            // 				height:'100',
            // 				imgName: '图片',
            // 				imgDirection: 0,state:true,
            // 			},
            // 			events: [],
            // 			variableEvents: [],
            // 		 },
            // 		 {
            // 			type: "img",
            // 			name: '箭头-59',
            // 			url: '/static/picture/A/arrow/fmarrow (58).bmp',
            // 			wrapperStyle:{
            // 				width:'100px',
            // 				height:'100px',
            // 			},
            // 			style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 			},
            // 			settings:{
            // 				width:'100',
            // 				height:'100',
            // 				imgName: '图片',
            // 				imgDirection: 0,state:true,
            // 			},
            // 			realtimeData:{
            // 				width:'100',
            // 				height:'100',
            // 				imgName: '图片',
            // 				imgDirection: 0,state:true,
            // 			},
            // 			events: [],
            // 			variableEvents: [],
            // 		 },
            // 		 ///////////
            // 		 {
            // 			type: "img",
            // 			name: '箭头-60',
            // 			url: '/static/picture/A/arrow/fmarrow (59).bmp',
            // 			wrapperStyle:{
            // 				width:'100px',
            // 				height:'100px',
            // 			},
            // 			style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 			},
            // 			settings:{
            // 				width:'100',
            // 				height:'100',
            // 				imgName: '图片',
            // 				imgDirection: 0,state:true,
            // 			},
            // 			realtimeData:{
            // 				width:'100',
            // 				height:'100',
            // 				imgName: '图片',
            // 				imgDirection: 0,state:true,
            // 			},
            // 			events: [],
            // 			variableEvents: [],
            // 		 },
            // 	 {
            // 		type: "img",
            // 		name: '箭头-61',
            // 		url: '/static/picture/A/arrow/fmarrow (60).bmp',
            // 		wrapperStyle:{
            // 			width:'100px',
            // 			height:'100px',
            // 		},
            // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 		},
            // 		settings:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		realtimeData:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		events: [],
            // 		variableEvents: [],
            // 	 },
            // 	 {
            // 		type: "img",
            // 		name: '箭头-62',
            // 		url: '/static/picture/A/arrow/fmarrow (61).bmp',
            // 		wrapperStyle:{
            // 			width:'100px',
            // 			height:'100px',
            // 		},
            // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 		},
            // 		settings:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		realtimeData:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		events: [],
            // 		variableEvents: [],
            // 	 },
            // 	 {
            // 		type: "img",
            // 		name: '箭头-63',
            // 		url: '/static/picture/A/arrow/fmarrow (62).bmp',
            // 		wrapperStyle:{
            // 			width:'100px',
            // 			height:'100px',
            // 		},
            // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 		},
            // 		settings:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		realtimeData:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		events: [],
            // 		variableEvents: [],
            // 	 },
            // 	 {
            // 		type: "img",
            // 		name: '箭头-64',
            // 		url: '/static/picture/A/arrow/fmarrow (63).bmp',
            // 		wrapperStyle:{
            // 			width:'100px',
            // 			height:'100px',
            // 		},
            // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 		},
            // 		settings:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		realtimeData:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		events: [],
            // 		variableEvents: [],
            // 	 },
            // 	 {
            // 		type: "img",
            // 		name: '箭头-65',
            // 		url: '/static/picture/A/arrow/fmarrow (64).bmp',
            // 		wrapperStyle:{
            // 			width:'100px',
            // 			height:'100px',
            // 		},
            // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 		},
            // 		settings:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		realtimeData:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		events: [],
            // 		variableEvents: [],
            // 	 },
            // 	 {
            // 		type: "img",
            // 		name: '箭头-66',
            // 		url: '/static/picture/A/arrow/fmarrow (65).bmp',
            // 		wrapperStyle:{
            // 			width:'100px',
            // 			height:'100px',
            // 		},
            // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 		},
            // 		settings:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		realtimeData:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		events: [],
            // 		variableEvents: [],
            // 	 },
            // 	 {
            // 		type: "img",
            // 		name: '箭头-67',
            // 		url: '/static/picture/A/arrow/fmarrow (66).bmp',
            // 		wrapperStyle:{
            // 			width:'100px',
            // 			height:'100px',
            // 		},
            // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 		},
            // 		settings:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		realtimeData:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		events: [],
            // 		variableEvents: [],
            // 	 },
            // 	 {
            // 		type: "img",
            // 		name: '箭头-68',
            // 		url: '/static/picture/A/arrow/fmarrow (67).bmp',
            // 		wrapperStyle:{
            // 			width:'100px',
            // 			height:'100px',
            // 		},
            // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 		},
            // 		settings:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		realtimeData:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		events: [],
            // 		variableEvents: [],
            // 	 },
            // 	 {
            // 		type: "img",
            // 		name: '箭头-69',
            // 		url: '/static/picture/A/arrow/fmarrow (68).bmp',
            // 		wrapperStyle:{
            // 			width:'100px',
            // 			height:'100px',
            // 		},
            // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 		},
            // 		settings:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		realtimeData:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		events: [],
            // 		variableEvents: [],
            // 	 },
            // 	 {
            // 		type: "img",
            // 		name: '箭头-70',
            // 		url: '/static/picture/A/arrow/fmarrow (69).bmp',
            // 		wrapperStyle:{
            // 			width:'100px',
            // 			height:'100px',
            // 		},
            // 		style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 		},
            // 		settings:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		realtimeData:{
            // 			width:'100',
            // 			height:'100',
            // 			imgName: '图片',
            // 			imgDirection: 0,state:true,
            // 		},
            // 		events: [],
            // 		variableEvents: [],
            // 	 },
            // 	 ///////////
            // 							 {
            // 								type: "img",
            // 								name: '箭头-71',
            // 								url: '/static/picture/A/arrow/fmarrow (70).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-72',
            // 								url: '/static/picture/A/arrow/fmarrow (71).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-73',
            // 								url: '/static/picture/A/arrow/fmarrow (72).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-74',
            // 								url: '/static/picture/A/arrow/fmarrow (73).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-75',
            // 								url: '/static/picture/A/arrow/fmarrow (74).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-76',
            // 								url: '/static/picture/A/arrow/fmarrow (75).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-77',
            // 								url: '/static/picture/A/arrow/fmarrow (76).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-78',
            // 								url: '/static/picture/A/arrow/fmarrow (77).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-79',
            // 								url: '/static/picture/A/arrow/fmarrow (78).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-80',
            // 								url: '/static/picture/A/arrow/fmarrow (79).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-81',
            // 								url: '/static/picture/A/arrow/fmarrow (80).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 ///////////
            // 							 {
            // 								type: "img",
            // 								name: '箭头-82',
            // 								url: '/static/picture/A/arrow/fmarrow (81).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-83',
            // 								url: '/static/picture/A/arrow/fmarrow (82).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-84',
            // 								url: '/static/picture/A/arrow/fmarrow (83).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-85',
            // 								url: '/static/picture/A/arrow/fmarrow (84).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-86',
            // 								url: '/static/picture/A/arrow/fmarrow (85).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-87',
            // 								url: '/static/picture/A/arrow/fmarrow (86).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-88',
            // 								url: '/static/picture/A/arrow/fmarrow (87).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-89',
            // 								url: '/static/picture/A/arrow/fmarrow (88).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-90',
            // 								url: '/static/picture/A/arrow/fmarrow (89).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-91',
            // 								url: '/static/picture/A/arrow/fmarrow (90).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-92',
            // 								url: '/static/picture/A/arrow/fmarrow (91).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 ///////////
            // 							 {
            // 								type: "img",
            // 								name: '箭头-93',
            // 								url: '/static/picture/A/arrow/fmarrow (92).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-94',
            // 								url: '/static/picture/A/arrow/fmarrow (93).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-95',
            // 								url: '/static/picture/A/arrow/fmarrow (94).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-96',
            // 								url: '/static/picture/A/arrow/fmarrow (95).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-97',
            // 								url: '/static/picture/A/arrow/fmarrow (96).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-98',
            // 								url: '/static/picture/A/arrow/fmarrow (97).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-99',
            // 								url: '/static/picture/A/arrow/fmarrow (98).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-100',
            // 								url: '/static/picture/A/arrow/fmarrow (99).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-101',
            // 								url: '/static/picture/A/arrow/fmarrow (100).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-102',
            // 								url: '/static/picture/A/arrow/fmarrow (101).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-103',
            // 								url: '/static/picture/A/arrow/fmarrow (102).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 ///////////
            // 							 {
            // 								type: "img",
            // 								name: '箭头-104',
            // 								url: '/static/picture/A/arrow/fmarrow (103).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },
            // 							 {
            // 								type: "img",
            // 								name: '箭头-105',
            // 								url: '/static/picture/A/arrow/fmarrow (104).bmp',
            // 								wrapperStyle:{
            // 									width:'100px',
            // 									height:'100px',
            // 								},
            // 								style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								},
            // 								settings:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								realtimeData:{
            // 									width:'100',
            // 									height:'100',
            // 									imgName: '图片',
            // 									imgDirection: 0,state:true,
            // 								},
            // 								events: [],
            // 								variableEvents: [],
            // 							 },


            // ]
            // },
            // {id0:6,name:'开关',showPicture: false,
            // pictureList:[
            // 								{
            // 									type: "img",
            // 									name: '开关-1',
            // 									url: '/static/picture/A/togle/fmTogle11.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '开关-2',
            // 									url: '/static/picture/A/togle/fmTogle12.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '开关-3',
            // 									url: '/static/picture/A/togle/fmTogle21.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '开关-4',
            // 									url: '/static/picture/A/togle/fmTogle22.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '开关-5',
            // 									url: '/static/picture/A/togle/fmTogle31.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '开关-6',
            // 									url: '/static/picture/A/togle/fmTogle32.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '开关-7',
            // 									url: '/static/picture/A/togle/fmTogle41.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '开关-8',
            // 									url: '/static/picture/A/togle/fmTogle42.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '开关-9',
            // 									url: '/static/picture/A/togle/fmTogle51.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '开关-10',
            // 									url: '/static/picture/A/togle/fmTogle52.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '开关-11',
            // 									url: '/static/picture/A/togle/fmTogle61.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '开关-12',
            // 									url: '/static/picture/A/togle/fmTogle62.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '开关-13',
            // 									url: '/static/picture/A/togle/fmTogle71.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '开关-14',
            // 									url: '/static/picture/A/togle/fmTogle72.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },

            // ]
            // },
            // {id0:7,name:'小图形',showPicture: false,
            // pictureList:[
            // 	{
            // 									type: "img",
            // 									name: '小图形-1',
            // 									url: '/static/picture/A/smallBmp/fmSmallBmp001.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '小图形-2',
            // 									url: '/static/picture/A/smallBmp/fmSmallBmp002.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '小图形-3',
            // 									url: '/static/picture/A/smallBmp/fmSmallBmp003.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '小图形-4',
            // 									url: '/static/picture/A/smallBmp/fmSmallBmp004.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '小图形-5',
            // 									url: '/static/picture/A/smallBmp/fmSmallBmp005.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '小图形-6',
            // 									url: '/static/picture/A/smallBmp/fmSmallBmp006.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '小图形-7',
            // 									url: '/static/picture/A/smallBmp/fmSmallBmp007.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '小图形-8',
            // 									url: '/static/picture/A/smallBmp/fmSmallBmp008.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '小图形-9',
            // 									url: '/static/picture/A/smallBmp/fmSmallBmp009.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '小图形-10',
            // 									url: '/static/picture/A/smallBmp/fmSmallBmp010.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '小图形-11',
            // 									url: '/static/picture/A/smallBmp/fmSmallBmp011.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '小图形-12',
            // 									url: '/static/picture/A/smallBmp/fmSmallBmp012.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '小图形-13',
            // 									url: '/static/picture/A/smallBmp/fmSmallBmp013.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '小图形-14',
            // 									url: '/static/picture/A/smallBmp/fmSmallBmp014.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '小图形-15',
            // 									url: '/static/picture/A/smallBmp/fmSmallBmp015.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },

            // ]

            // },
            // {id0:8,name:'自然',showPicture: false,
            // pictureList:[
            // 	{
            // 									type: "img",
            // 									name: '自然-1',
            // 									url: '/static/picture/A/nature/Blister1.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-2',
            // 									url: '/static/picture/A/nature/Blister2.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 								 													type: "img",
            // 								 													name: '自然-3',
            // 								 													url: '/static/picture/A/nature/Blister3.bmp',
            // 								 													wrapperStyle:{
            // 								 														width:'100px',
            // 								 														height:'100px',
            // 								 													},
            // 								 													style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 								 													},
            // 								 													settings:{
            // 								 														width:'100',
            // 								 														height:'100',
            // 								 														imgName: '图片',
            // 								 														imgDirection: 0,state:true,
            // 								 													},
            // 								 													realtimeData:{
            // 								 														width:'100',
            // 								 														height:'100',
            // 								 														imgName: '图片',
            // 								 														imgDirection: 0,state:true,
            // 								 													},
            // 								 													events: [],
            // 								 													variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-4',
            // 									url: '/static/picture/A/nature/Cloud1.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-5',
            // 									url: '/static/picture/A/nature/Cloud2.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-6',
            // 									url: '/static/picture/A/nature/fCloud3.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-7',
            // 									url: '/static/picture/A/nature/Cloud4.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-8',
            // 									url: '/static/picture/A/nature/Cloud5.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-9',
            // 									url: '/static/picture/A/nature/Cloud6.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-10',
            // 									url: '/static/picture/A/nature/Cloud7.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-11',
            // 									url: '/static/picture/A/nature/Cloud8.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-12',
            // 									url: '/static/picture/A/nature/Cloud9.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-13',
            // 									url: '/static/picture/A/nature/Cloud10.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-14',
            // 									url: '/static/picture/A/nature/Drop1.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-15',
            // 									url: '/static/picture/A/nature/Drop2.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 ///////////
            // 								 {
            // 									type: "img",
            // 									name: '自然-16',
            // 									url: '/static/picture/A/nature/Drop3.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-17',
            // 									url: '/static/picture/A/nature/Fire1.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-18',
            // 									url: '/static/picture/A/nature/Fire2.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-19',
            // 									url: '/static/picture/A/nature/Fire3.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-20',
            // 									url: '/static/picture/A/nature/Fire4.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-21',
            // 									url: '/static/picture/A/nature/Fire5.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-22',
            // 									url: '/static/picture/A/nature/Fire6.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-23',
            // 									url: '/static/picture/A/nature/Fire7.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-24',
            // 									url: '/static/picture/A/nature/Fire8.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-25',
            // 									url: '/static/picture/A/nature/Fire9.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-26',
            // 									url: '/static/picture/A/nature/Fireb1.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 ///////////
            // 								 {
            // 									type: "img",
            // 									name: '自然-27',
            // 									url: '/static/picture/A/nature/Fireb2.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-28',
            // 									url: '/static/picture/A/nature/Fireb3.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-29',
            // 									url: '/static/picture/A/nature/Fireb4.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-30',
            // 									url: '/static/picture/A/nature/Firem1.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-31',
            // 									url: '/static/picture/A/nature/Firem2.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-32',
            // 									url: '/static/picture/A/nature/Firem3.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-33',
            // 									url: '/static/picture/A/nature/Hill1.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-34',
            // 									url: '/static/picture/A/nature/Hill2.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-35',
            // 									url: '/static/picture/A/nature/Hill3.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-36',
            // 									url: '/static/picture/A/nature/Hill4.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-37',
            // 									url: '/static/picture/A/nature/Hill5.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 ///////////
            // 								 {
            // 									type: "img",
            // 									name: '自然-38',
            // 									url: '/static/picture/A/nature/Hill6.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-39',
            // 									url: '/static/picture/A/nature/Moon.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-40',
            // 									url: '/static/picture/A/nature/Tree1.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-41',
            // 									url: '/static/picture/A/nature/Tree2.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-42',
            // 									url: '/static/picture/A/nature/Tree3.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-43',
            // 									url: '/static/picture/A/nature/Tree4.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-44',
            // 									url: '/static/picture/A/nature/Tree5.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-45',
            // 									url: '/static/picture/A/nature/Tree6.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-46',
            // 									url: '/static/picture/A/nature/Tree7.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-47',
            // 									url: '/static/picture/A/nature/Tree8.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-48',
            // 									url: '/static/picture/A/nature/Tree9.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 ///////////
            // 								 {
            // 									type: "img",
            // 									name: '自然-49',
            // 									url: '/static/picture/A/nature/Tree10.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },
            // 								 {
            // 									type: "img",
            // 									name: '自然-50',
            // 									url: '/static/picture/A/nature/Tree11.bmp',
            // 									wrapperStyle:{
            // 										width:'100px',
            // 										height:'100px',
            // 									},
            // 									style:{'transform': 'rotate(0deg)',width:'100px',height:'100px',

            // 									},
            // 									settings:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									realtimeData:{
            // 										width:'100',
            // 										height:'100',
            // 										imgName: '图片',
            // 										imgDirection: 0,state:true,
            // 									},
            // 									events: [],
            // 									variableEvents: [],
            // 								 },

            // ]
            // },
            {
                id0: 5, name: '反应器', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '反应器-1',
                        url: '/static/picture/A/reactor/Other06.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '反应器-2',
                        url: '/static/picture/A/reactor/Other07.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '反应器-3',
                        url: '/static/picture/A/reactor/Other08.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    }
                ],
            },
            {
                id0: 6, name: '管道', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '管道-1',
                        url: '/static/picture/A/pipeline/fmtank (35).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-2',
                        url: '/static/picture/A/pipeline/fmtank (36).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-3',
                        url: '/static/picture/A/pipeline/fmtank (37).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-4',
                        url: '/static/picture/A/pipeline/Map4.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-5',
                        url: '/static/picture/A/pipeline/Map11.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-6',
                        url: '/static/picture/A/pipeline/Map12.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-7',
                        url: '/static/picture/A/pipeline/Map13.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-8',
                        url: '/static/picture/A/pipeline/Map14.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-9',
                        url: '/static/picture/A/pipeline/Map15.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-10',
                        url: '/static/picture/A/pipeline/Map16.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-11',
                        url: '/static/picture/A/pipeline/Map17.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-12',
                        url: '/static/picture/A/pipeline/Map18.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-13',
                        url: '/static/picture/A/pipeline/Map19.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-14',
                        url: '/static/picture/A/pipeline/Map21.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-15',
                        url: '/static/picture/A/pipeline/Map22.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    }
                ],
            },
            {
                id0: 7, name: '火焰水滴', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '火焰水滴-1',
                        url: '/static/picture/A/fireDrop/Drop1.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '火焰水滴-2',
                        url: '/static/picture/A/fireDrop/Drop2.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '火焰水滴-3',
                        url: '/static/picture/A/fireDrop/Drop3.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '火焰水滴-4',
                        url: '/static/picture/A/fireDrop/Fire1.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '火焰水滴-5',
                        url: '/static/picture/A/fireDrop/Fire3.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '火焰水滴-6',
                        url: '/static/picture/A/fireDrop/Fire4.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '火焰水滴-7',
                        url: '/static/picture/A/fireDrop/Fire5.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '火焰水滴-8',
                        url: '/static/picture/A/fireDrop/Fire6.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '火焰水滴-9',
                        url: '/static/picture/A/fireDrop/Fire7.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '火焰水滴-10',
                        url: '/static/picture/A/fireDrop/Fire8.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '火焰水滴-11',
                        url: '/static/picture/A/fireDrop/Fire9.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '火焰水滴-12',
                        url: '/static/picture/A/fireDrop/Fireb1.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '火焰水滴-13',
                        url: '/static/picture/A/fireDrop/Fireb2.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '火焰水滴-14',
                        url: '/static/picture/A/fireDrop/Fireb3.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '火焰水滴-15',
                        url: '/static/picture/A/fireDrop/Fireb4.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '火焰水滴-16',
                        url: '/static/picture/A/fireDrop/Firem1.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '火焰水滴-17',
                        url: '/static/picture/A/fireDrop/Firem2.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '火焰水滴-18',
                        url: '/static/picture/A/fireDrop/Firem3.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    }
                ],
            },
            {
                id0: 8, name: '搅拌', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '搅拌-1',
                        url: '/static/picture/A/stirrer/Other10.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '搅拌-2',
                        url: '/static/picture/A/stirrer/Other11.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '搅拌-3',
                        url: '/static/picture/A/stirrer/Other18.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    }
                ],
            },
            {
                id0: 9, name: '形状', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '形状-1',
                        url: '/static/picture/A/shape/ISA-05.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '形状-2',
                        url: '/static/picture/A/shape/ISA-06.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '形状-3',
                        url: '/static/picture/A/shape/ISA-07.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '形状-4',
                        url: '/static/picture/A/shape/ISA-08.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '形状-5',
                        url: '/static/picture/A/shape/ISA-10.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '形状-6',
                        url: '/static/picture/A/shape/ISA-11.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '形状-7',
                        url: '/static/picture/A/shape/ISA-15.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '形状-8',
                        url: '/static/picture/A/shape/ISA-26.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    }
                ],
            },
            {
                id0: 10, name: '植物', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '植物-1',
                        url: '/static/picture/A/plant/Tree1.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '植物-2',
                        url: '/static/picture/A/plant/Tree2.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '植物-3',
                        url: '/static/picture/A/plant/Tree3.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '植物-4',
                        url: '/static/picture/A/plant/Tree4.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '植物-5',
                        url: '/static/picture/A/plant/Tree5.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '植物-6',
                        url: '/static/picture/A/plant/Tree6.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '植物-7',
                        url: '/static/picture/A/plant/Tree7.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '植物-8',
                        url: '/static/picture/A/plant/Tree8.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '植物-9',
                        url: '/static/picture/A/plant/Tree9.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '植物-10',
                        url: '/static/picture/A/plant/Tree10.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '植物-11',
                        url: '/static/picture/A/plant/Tree11.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    }
                ],
            },
            {
                id0: 11, name: '运输', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '运输-1',
                        url: '/static/picture/A/transport/fmtank (9).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '运输-2',
                        url: '/static/picture/A/transport/fmtank (10).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '运输-3',
                        url: '/static/picture/A/transport/fmtank (85).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    }
                ],
            },
            {
                id0: 12, name: '指示灯', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '指示灯-1',
                        url: '/static/picture/A/light/fmPilotLight_1.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-2',
                        url: '/static/picture/A/light/fmPilotLight_2.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-3',
                        url: '/static/picture/A/light/fmPilotLight_3.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-4',
                        url: '/static/picture/A/light/fmPilotLight_4.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-5',
                        url: '/static/picture/A/light/fmPilotLight_5.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-6',
                        url: '/static/picture/A/light/fmPilotLight_6.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-7',
                        url: '/static/picture/A/light/fmPilotLight_7.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-8',
                        url: '/static/picture/A/light/fmPilotLight_8.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-9',
                        url: '/static/picture/A/light/fmPilotLight_9.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-10',
                        url: '/static/picture/A/light/fmPilotLight_10.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-11',
                        url: '/static/picture/A/light/fmPilotLight_11.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-12',
                        url: '/static/picture/A/light/fmPilotLight_12.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-13',
                        url: '/static/picture/A/light/fmPilotLight_13.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-14',
                        url: '/static/picture/A/light/fmPilotLight_14.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-15',
                        url: '/static/picture/A/light/fmPilotLight_15.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-16',
                        url: '/static/picture/A/light/fmPilotLight_16.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-17',
                        url: '/static/picture/A/light/fmPilotLight_17.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-18',
                        url: '/static/picture/A/light/fmPilotLight_18.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-19',
                        url: '/static/picture/A/light/fmPilotLight_19.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-20',
                        url: '/static/picture/A/light/fmPilotLight_20.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-21',
                        url: '/static/picture/A/light/fmPilotLight_21.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-22',
                        url: '/static/picture/A/light/fmPilotLight_22.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-23',
                        url: '/static/picture/A/light/fmPilotLight_23.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-24',
                        url: '/static/picture/A/light/fmPilotLight_24.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-25',
                        url: '/static/picture/A/light/fmPilotLight_25.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-26',
                        url: '/static/picture/A/light/fmPilotLight_26.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '指示灯-27',
                        url: '/static/picture/A/light/fmPilotLight_27.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    }

                ],
            },
            {
                id0: 13, name: '其他', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '其他-1',
                        url: '/static/picture/A/other/Other12.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他-2',
                        url: '/static/picture/A/other/Other13.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他-3',
                        url: '/static/picture/A/other/Other14.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他-4',
                        url: '/static/picture/A/other/Other15.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他-5',
                        url: '/static/picture/A/other/Other16.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    }
                ],
            },
        ],
        showContent: false,
    },
    {
        id: 2,
        name: '各种图形',
        type: [
            {
                id0: 0, name: '图形A', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '图形A-1',
                        url: '/static/picture/B/ISA/ISA-57.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-2',
                        url: '/static/picture/B/ISA/ISA-01.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-3',
                        url: '/static/picture/B/ISA/ISA-02.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-4',
                        url: '/static/picture/B/ISA/ISA-03.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-5',
                        url: '/static/picture/B/ISA/ISA-04.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-6',
                        url: '/static/picture/B/ISA/ISA-05.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-7',
                        url: '/static/picture/B/ISA/ISA-06.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-8',
                        url: '/static/picture/B/ISA/ISA-07.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-9',
                        url: '/static/picture/B/ISA/ISA-08.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-10',
                        url: '/static/picture/B/ISA/ISA-09.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-11',
                        url: '/static/picture/B/ISA/ISA-10.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-12',
                        url: '/static/picture/B/ISA/ISA-11.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-13',
                        url: '/static/picture/B/ISA/ISA-12.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-14',
                        url: '/static/picture/B/ISA/ISA-13.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-15',
                        url: '/static/picture/B/ISA/ISA-14.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图形A-16',
                        url: '/static/picture/B/ISA/ISA-15.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-17',
                        url: '/static/picture/B/ISA/ISA-16.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-18',
                        url: '/static/picture/B/ISA/ISA-17.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-19',
                        url: '/static/picture/B/ISA/ISA-18.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-20',
                        url: '/static/picture/B/ISA/ISA-19.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-21',
                        url: '/static/picture/B/ISA/ISA-20.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-22',
                        url: '/static/picture/B/ISA/ISA-21.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-23',
                        url: '/static/picture/B/ISA/ISA-22.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-24',
                        url: '/static/picture/B/ISA/ISA-23.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-25',
                        url: '/static/picture/B/ISA/ISA-24.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-26',
                        url: '/static/picture/B/ISA/ISA-25.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图形A-27',
                        url: '/static/picture/B/ISA/ISA-26.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-28',
                        url: '/static/picture/B/ISA/ISA-27.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-29',
                        url: '/static/picture/B/ISA/ISA-28.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-30',
                        url: '/static/picture/B/ISA/ISA-29.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-31',
                        url: '/static/picture/B/ISA/ISA-30.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-32',
                        url: '/static/picture/B/ISA/ISA-31.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-33',
                        url: '/static/picture/B/ISA/ISA-32.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-34',
                        url: '/static/picture/B/ISA/ISA-33.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-35',
                        url: '/static/picture/B/ISA/ISA-34.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-36',
                        url: '/static/picture/B/ISA/ISA-35.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-37',
                        url: '/static/picture/B/ISA/ISA-36.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图形A-38',
                        url: '/static/picture/B/ISA/ISA-37.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-39',
                        url: '/static/picture/B/ISA/ISA-38.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-40',
                        url: '/static/picture/B/ISA/ISA-39.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-41',
                        url: '/static/picture/B/ISA/ISA-40.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-42',
                        url: '/static/picture/B/ISA/ISA-41.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-43',
                        url: '/static/picture/B/ISA/ISA-42.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-44',
                        url: '/static/picture/B/ISA/ISA-43.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-45',
                        url: '/static/picture/B/ISA/ISA-44.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-46',
                        url: '/static/picture/B/ISA/ISA-45.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-47',
                        url: '/static/picture/B/ISA/ISA-46.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-48',
                        url: '/static/picture/B/ISA/ISA-47.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图形A-49',
                        url: '/static/picture/B/ISA/ISA-48.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-50',
                        url: '/static/picture/B/ISA/ISA-49.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-51',
                        url: '/static/picture/B/ISA/ISA-50.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-52',
                        url: '/static/picture/B/ISA/ISA-51.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-53',
                        url: '/static/picture/B/ISA/ISA-52.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-54',
                        url: '/static/picture/B/ISA/ISA-53.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-55',
                        url: '/static/picture/B/ISA/ISA-54.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-56',
                        url: '/static/picture/B/ISA/ISA-55.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形A-57',
                        url: '/static/picture/B/ISA/ISA-56.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 1, name: '图形B', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '图形B-1',
                        url: '/static/picture/B/map/Map22.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-2',
                        url: '/static/picture/B/map/Map1.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-3',
                        url: '/static/picture/B/map/Map2.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-4',
                        url: '/static/picture/B/map/Map3.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-5',
                        url: '/static/picture/B/map/Map4.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-6',
                        url: '/static/picture/B/map/Map5.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-7',
                        url: '/static/picture/B/map/Map6.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-8',
                        url: '/static/picture/B/map/Map7.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-9',
                        url: '/static/picture/B/map/Map8.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-10',
                        url: '/static/picture/B/map/Map9.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-11',
                        url: '/static/picture/B/map/Map10.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-12',
                        url: '/static/picture/B/map/Map11.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-13',
                        url: '/static/picture/B/map/Map12.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-14',
                        url: '/static/picture/B/map/Map13.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-15',
                        url: '/static/picture/B/map/Map14.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图形B-16',
                        url: '/static/picture/B/map/Map15.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-17',
                        url: '/static/picture/B/map/Map16.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-18',
                        url: '/static/picture/B/map/Map17.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-19',
                        url: '/static/picture/B/map/Map18.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-20',
                        url: '/static/picture/B/map/Map19.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-21',
                        url: '/static/picture/B/map/Map20.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图形B-22',
                        url: '/static/picture/B/map/Map21.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
        ],
        showContent: false,
    },
    {
        id: 3,
        name: '图示图标',
        type: [
            {
                id0: 0, name: '图标A', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '图标A-1',
                        url: '/static/picture/C/icon1/FvIcon_100.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-2',
                        url: '/static/picture/C/icon1/FvIcon_001.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-3',
                        url: '/static/picture/C/icon1/FvIcon_002.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-4',
                        url: '/static/picture/C/icon1/FvIcon_003.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-5',
                        url: '/static/picture/C/icon1/FvIcon_004.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-6',
                        url: '/static/picture/C/icon1/FvIcon_005.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-7',
                        url: '/static/picture/C/icon1/FvIcon_006.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-8',
                        url: '/static/picture/C/icon1/FvIcon_007.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-9',
                        url: '/static/picture/C/icon1/FvIcon_008.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-10',
                        url: '/static/picture/C/icon1/FvIcon_009.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-11',
                        url: '/static/picture/C/icon1/FvIcon_010.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-12',
                        url: '/static/picture/C/icon1/FvIcon_011.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-13',
                        url: '/static/picture/C/icon1/FvIcon_012.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-14',
                        url: '/static/picture/C/icon1/FvIcon_013.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-15',
                        url: '/static/picture/C/icon1/FvIcon_014.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标A-16',
                        url: '/static/picture/C/icon1/FvIcon_015.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-17',
                        url: '/static/picture/C/icon1/FvIcon_016.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-18',
                        url: '/static/picture/C/icon1/FvIcon_017.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-19',
                        url: '/static/picture/C/icon1/FvIcon_018.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-20',
                        url: '/static/picture/C/icon1/FvIcon_019.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-21',
                        url: '/static/picture/C/icon1/FvIcon_020.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-22',
                        url: '/static/picture/C/icon1/FvIcon_021.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-23',
                        url: '/static/picture/C/icon1/FvIcon_022.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-24',
                        url: '/static/picture/C/icon1/FvIcon_023.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-25',
                        url: '/static/picture/C/icon1/FvIcon_024.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-26',
                        url: '/static/picture/C/icon1/FvIcon_025.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标A-27',
                        url: '/static/picture/C/icon1/FvIcon_026.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-28',
                        url: '/static/picture/C/icon1/FvIcon_027.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-29',
                        url: '/static/picture/C/icon1/FvIcon_028.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-30',
                        url: '/static/picture/C/icon1/FvIcon_029.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-31',
                        url: '/static/picture/C/icon1/FvIcon_030.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-32',
                        url: '/static/picture/C/icon1/FvIcon_031.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-33',
                        url: '/static/picture/C/icon1/FvIcon_032.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-34',
                        url: '/static/picture/C/icon1/FvIcon_033.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-35',
                        url: '/static/picture/C/icon1/FvIcon_034.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-36',
                        url: '/static/picture/C/icon1/FvIcon_035.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-37',
                        url: '/static/picture/C/icon1/FvIcon_036.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标A-38',
                        url: '/static/picture/C/icon1/FvIcon_037.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-39',
                        url: '/static/picture/C/icon1/FvIcon_038.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-40',
                        url: '/static/picture/C/icon1/FvIcon_039.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-41',
                        url: '/static/picture/C/icon1/FvIcon_040.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-42',
                        url: '/static/picture/C/icon1/FvIcon_041.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-43',
                        url: '/static/picture/C/icon1/FvIcon_042.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-44',
                        url: '/static/picture/C/icon1/FvIcon_043.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-45',
                        url: '/static/picture/C/icon1/FvIcon_044.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-46',
                        url: '/static/picture/C/icon1/FvIcon_045.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-47',
                        url: '/static/picture/C/icon1/FvIcon_046.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-48',
                        url: '/static/picture/C/icon1/FvIcon_047.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标A-49',
                        url: '/static/picture/C/icon1/FvIcon_048.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-50',
                        url: '/static/picture/C/icon1/FvIcon_049.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-51',
                        url: '/static/picture/C/icon1/FvIcon_050.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-52',
                        url: '/static/picture/C/icon1/FvIcon_051.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-53',
                        url: '/static/picture/C/icon1/FvIcon_052.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-54',
                        url: '/static/picture/C/icon1/FvIcon_053.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-55',
                        url: '/static/picture/C/icon1/FvIcon_054.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-56',
                        url: '/static/picture/C/icon1/FvIcon_055.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-57',
                        url: '/static/picture/C/icon1/FvIcon_056.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-58',
                        url: '/static/picture/C/icon1/FvIcon_057.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-59',
                        url: '/static/picture/C/icon1/FvIcon_058.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标A-60',
                        url: '/static/picture/C/icon1/FvIcon_059.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-61',
                        url: '/static/picture/C/icon1/FvIcon_060.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-62',
                        url: '/static/picture/C/icon1/FvIcon_061.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-63',
                        url: '/static/picture/C/icon1/FvIcon_062.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-64',
                        url: '/static/picture/C/icon1/FvIcon_063.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-65',
                        url: '/static/picture/C/icon1/FvIcon_064.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-66',
                        url: '/static/picture/C/icon1/FvIcon_065.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-67',
                        url: '/static/picture/C/icon1/FvIcon_066.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-68',
                        url: '/static/picture/C/icon1/FvIcon_067.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-69',
                        url: '/static/picture/C/icon1/FvIcon_068.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-70',
                        url: '/static/picture/C/icon1/FvIcon_069.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标A-71',
                        url: '/static/picture/C/icon1/FvIcon_070.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-72',
                        url: '/static/picture/C/icon1/FvIcon_071.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-73',
                        url: '/static/picture/C/icon1/FvIcon_072.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-74',
                        url: '/static/picture/C/icon1/FvIcon_073.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-75',
                        url: '/static/picture/C/icon1/FvIcon_074.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-76',
                        url: '/static/picture/C/icon1/FvIcon_075.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-77',
                        url: '/static/picture/C/icon1/FvIcon_076.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-78',
                        url: '/static/picture/C/icon1/FvIcon_077.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-79',
                        url: '/static/picture/C/icon1/FvIcon_078.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-80',
                        url: '/static/picture/C/icon1/FvIcon_079.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-81',
                        url: '/static/picture/C/icon1/FvIcon_080.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标A-82',
                        url: '/static/picture/C/icon1/FvIcon_081.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-83',
                        url: '/static/picture/C/icon1/FvIcon_082.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-84',
                        url: '/static/picture/C/icon1/FvIcon_083.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-85',
                        url: '/static/picture/C/icon1/FvIcon_084.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-86',
                        url: '/static/picture/C/icon1/FvIcon_085.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-87',
                        url: '/static/picture/C/icon1/FvIcon_086.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-88',
                        url: '/static/picture/C/icon1/FvIcon_087.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-89',
                        url: '/static/picture/C/icon1/FvIcon_088.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-90',
                        url: '/static/picture/C/icon1/FvIcon_089.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-91',
                        url: '/static/picture/C/icon1/FvIcon_090.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-92',
                        url: '/static/picture/C/icon1/FvIcon_091.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标A-93',
                        url: '/static/picture/C/icon1/FvIcon_092.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-94',
                        url: '/static/picture/C/icon1/FvIcon_093.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-95',
                        url: '/static/picture/C/icon1/FvIcon_094.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-96',
                        url: '/static/picture/C/icon1/FvIcon_095.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-97',
                        url: '/static/picture/C/icon1/FvIcon_096.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-98',
                        url: '/static/picture/C/icon1/FvIcon_097.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-99',
                        url: '/static/picture/C/icon1/FvIcon_098.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标A-100',
                        url: '/static/picture/C/icon1/FvIcon_099.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 1, name: '图标B', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '图标B-1',
                        url: '/static/picture/C/icon2/FvIcon_200.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-2',
                        url: '/static/picture/C/icon2/FvIcon_101.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-3',
                        url: '/static/picture/C/icon2/FvIcon_102.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-4',
                        url: '/static/picture/C/icon2/FvIcon_103.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-5',
                        url: '/static/picture/C/icon2/FvIcon_104.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-6',
                        url: '/static/picture/C/icon2/FvIcon_105.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-7',
                        url: '/static/picture/C/icon2/FvIcon_106.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-8',
                        url: '/static/picture/C/icon2/FvIcon_107.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-9',
                        url: '/static/picture/C/icon2/FvIcon_108.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-10',
                        url: '/static/picture/C/icon2/FvIcon_109.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-11',
                        url: '/static/picture/C/icon2/FvIcon_110.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-12',
                        url: '/static/picture/C/icon2/FvIcon_111.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-13',
                        url: '/static/picture/C/icon2/FvIcon_112.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-14',
                        url: '/static/picture/C/icon2/FvIcon_113.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-15',
                        url: '/static/picture/C/icon2/FvIcon_114.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标B-16',
                        url: '/static/picture/C/icon2/FvIcon_115.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-17',
                        url: '/static/picture/C/icon2/FvIcon_116.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-18',
                        url: '/static/picture/C/icon2/FvIcon_117.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-19',
                        url: '/static/picture/C/icon2/FvIcon_118.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-20',
                        url: '/static/picture/C/icon2/FvIcon_119.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-21',
                        url: '/static/picture/C/icon2/FvIcon_120.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-22',
                        url: '/static/picture/C/icon2/FvIcon_121.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-23',
                        url: '/static/picture/C/icon2/FvIcon_122.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-24',
                        url: '/static/picture/C/icon2/FvIcon_123.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-25',
                        url: '/static/picture/C/icon2/FvIcon_124.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-26',
                        url: '/static/picture/C/icon2/FvIcon_125.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标B-27',
                        url: '/static/picture/C/icon2/FvIcon_126.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-28',
                        url: '/static/picture/C/icon2/FvIcon_127.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-29',
                        url: '/static/picture/C/icon2/FvIcon_128.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-30',
                        url: '/static/picture/C/icon2/FvIcon_129.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-31',
                        url: '/static/picture/C/icon2/FvIcon_130.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-32',
                        url: '/static/picture/C/icon2/FvIcon_131.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-33',
                        url: '/static/picture/C/icon2/FvIcon_132.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-34',
                        url: '/static/picture/C/icon2/FvIcon_133.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-35',
                        url: '/static/picture/C/icon2/FvIcon_134.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-36',
                        url: '/static/picture/C/icon2/FvIcon_135.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-37',
                        url: '/static/picture/C/icon2/FvIcon_136.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标B-38',
                        url: '/static/picture/C/icon2/FvIcon_137.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-39',
                        url: '/static/picture/C/icon2/FvIcon_138.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-40',
                        url: '/static/picture/C/icon2/FvIcon_139.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-41',
                        url: '/static/picture/C/icon2/FvIcon_140.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-42',
                        url: '/static/picture/C/icon2/FvIcon_141.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-43',
                        url: '/static/picture/C/icon2/FvIcon_142.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-44',
                        url: '/static/picture/C/icon2/FvIcon_143.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-45',
                        url: '/static/picture/C/icon2/FvIcon_144.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-46',
                        url: '/static/picture/C/icon2/FvIcon_145.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-47',
                        url: '/static/picture/C/icon2/FvIcon_146.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-48',
                        url: '/static/picture/C/icon2/FvIcon_147.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标B-49',
                        url: '/static/picture/C/icon2/FvIcon_148.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-50',
                        url: '/static/picture/C/icon2/FvIcon_149.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-51',
                        url: '/static/picture/C/icon2/FvIcon_150.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-52',
                        url: '/static/picture/C/icon2/FvIcon_151.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-53',
                        url: '/static/picture/C/icon2/FvIcon_152.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-54',
                        url: '/static/picture/C/icon2/FvIcon_153.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-55',
                        url: '/static/picture/C/icon2/FvIcon_154.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-56',
                        url: '/static/picture/C/icon2/FvIcon_155.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-57',
                        url: '/static/picture/C/icon2/FvIcon_156.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-58',
                        url: '/static/picture/C/icon2/FvIcon_157.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-59',
                        url: '/static/picture/C/icon2/FvIcon_158.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标B-60',
                        url: '/static/picture/C/icon2/FvIcon_159.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-61',
                        url: '/static/picture/C/icon2/FvIcon_160.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-62',
                        url: '/static/picture/C/icon2/FvIcon_161.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-63',
                        url: '/static/picture/C/icon2/FvIcon_162.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-64',
                        url: '/static/picture/C/icon2/FvIcon_163.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-65',
                        url: '/static/picture/C/icon2/FvIcon_164.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-66',
                        url: '/static/picture/C/icon2/FvIcon_165.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-67',
                        url: '/static/picture/C/icon2/FvIcon_166.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-68',
                        url: '/static/picture/C/icon2/FvIcon_167.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-69',
                        url: '/static/picture/C/icon2/FvIcon_168.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-70',
                        url: '/static/picture/C/icon2/FvIcon_169.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标B-71',
                        url: '/static/picture/C/icon2/FvIcon_170.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-72',
                        url: '/static/picture/C/icon2/FvIcon_171.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-73',
                        url: '/static/picture/C/icon2/FvIcon_172.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-74',
                        url: '/static/picture/C/icon2/FvIcon_173.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-75',
                        url: '/static/picture/C/icon2/FvIcon_174.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-76',
                        url: '/static/picture/C/icon2/FvIcon_175.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-77',
                        url: '/static/picture/C/icon2/FvIcon_176.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-78',
                        url: '/static/picture/C/icon2/FvIcon_177.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-79',
                        url: '/static/picture/C/icon2/FvIcon_178.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-80',
                        url: '/static/picture/C/icon2/FvIcon_179.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-81',
                        url: '/static/picture/C/icon2/FvIcon_180.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标B-82',
                        url: '/static/picture/C/icon2/FvIcon_181.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-83',
                        url: '/static/picture/C/icon2/FvIcon_182.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-84',
                        url: '/static/picture/C/icon2/FvIcon_183.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-85',
                        url: '/static/picture/C/icon2/FvIcon_184.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-86',
                        url: '/static/picture/C/icon2/FvIcon_185.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-87',
                        url: '/static/picture/C/icon2/FvIcon_186.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-88',
                        url: '/static/picture/C/icon2/FvIcon_187.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-89',
                        url: '/static/picture/C/icon2/FvIcon_188.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-90',
                        url: '/static/picture/C/icon2/FvIcon_189.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-91',
                        url: '/static/picture/C/icon2/FvIcon_190.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-92',
                        url: '/static/picture/C/icon2/FvIcon_191.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标B-93',
                        url: '/static/picture/C/icon2/FvIcon_192.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-94',
                        url: '/static/picture/C/icon2/FvIcon_193.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-95',
                        url: '/static/picture/C/icon2/FvIcon_194.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-96',
                        url: '/static/picture/C/icon2/FvIcon_195.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-97',
                        url: '/static/picture/C/icon2/FvIcon_196.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-98',
                        url: '/static/picture/C/icon2/FvIcon_197.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-99',
                        url: '/static/picture/C/icon2/FvIcon_198.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标B-100',
                        url: '/static/picture/C/icon2/FvIcon_199.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 2, name: '图标C', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '图标C-1',
                        url: '/static/picture/C/icon3/FvIcon_300.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-2',
                        url: '/static/picture/C/icon3/FvIcon_201.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-3',
                        url: '/static/picture/C/icon3/FvIcon_202.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-4',
                        url: '/static/picture/C/icon3/FvIcon_203.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-5',
                        url: '/static/picture/C/icon3/FvIcon_204.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-6',
                        url: '/static/picture/C/icon3/FvIcon_205.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-7',
                        url: '/static/picture/C/icon3/FvIcon_206.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-8',
                        url: '/static/picture/C/icon3/FvIcon_207.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-9',
                        url: '/static/picture/C/icon3/FvIcon_208.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-10',
                        url: '/static/picture/C/icon3/FvIcon_209.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-11',
                        url: '/static/picture/C/icon3/FvIcon_210.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-12',
                        url: '/static/picture/C/icon3/FvIcon_211.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-13',
                        url: '/static/picture/C/icon3/FvIcon_212.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-14',
                        url: '/static/picture/C/icon3/FvIcon_213.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-15',
                        url: '/static/picture/C/icon3/FvIcon_214.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标C-16',
                        url: '/static/picture/C/icon3/FvIcon_215.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-17',
                        url: '/static/picture/C/icon3/FvIcon_216.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-18',
                        url: '/static/picture/C/icon3/FvIcon_217.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-19',
                        url: '/static/picture/C/icon3/FvIcon_218.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-20',
                        url: '/static/picture/C/icon3/FvIcon_219.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-21',
                        url: '/static/picture/C/icon3/FvIcon_220.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-22',
                        url: '/static/picture/C/icon3/FvIcon_221.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-23',
                        url: '/static/picture/C/icon3/FvIcon_222.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-24',
                        url: '/static/picture/C/icon3/FvIcon_223.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-25',
                        url: '/static/picture/C/icon3/FvIcon_224.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-26',
                        url: '/static/picture/C/icon3/FvIcon_225.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标C-27',
                        url: '/static/picture/C/icon3/FvIcon_226.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-28',
                        url: '/static/picture/C/icon3/FvIcon_227.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-29',
                        url: '/static/picture/C/icon3/FvIcon_228.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-30',
                        url: '/static/picture/C/icon3/FvIcon_229.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-31',
                        url: '/static/picture/C/icon3/FvIcon_230.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-32',
                        url: '/static/picture/C/icon3/FvIcon_231.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-33',
                        url: '/static/picture/C/icon3/FvIcon_232.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-34',
                        url: '/static/picture/C/icon3/FvIcon_233.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-35',
                        url: '/static/picture/C/icon3/FvIcon_234.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-36',
                        url: '/static/picture/C/icon3/FvIcon_235.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-37',
                        url: '/static/picture/C/icon3/FvIcon_236.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标C-38',
                        url: '/static/picture/C/icon3/FvIcon_237.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-39',
                        url: '/static/picture/C/icon3/FvIcon_238.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-40',
                        url: '/static/picture/C/icon3/FvIcon_239.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-41',
                        url: '/static/picture/C/icon3/FvIcon_240.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-42',
                        url: '/static/picture/C/icon3/FvIcon_241.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-43',
                        url: '/static/picture/C/icon3/FvIcon_242.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-44',
                        url: '/static/picture/C/icon3/FvIcon_243.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-45',
                        url: '/static/picture/C/icon3/FvIcon_244.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-46',
                        url: '/static/picture/C/icon3/FvIcon_245.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-47',
                        url: '/static/picture/C/icon3/FvIcon_246.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-48',
                        url: '/static/picture/C/icon3/FvIcon_247.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标C-49',
                        url: '/static/picture/C/icon3/FvIcon_248.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-50',
                        url: '/static/picture/C/icon3/FvIcon_249.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-51',
                        url: '/static/picture/C/icon3/FvIcon_250.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-52',
                        url: '/static/picture/C/icon3/FvIcon_251.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-53',
                        url: '/static/picture/C/icon3/FvIcon_252.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-54',
                        url: '/static/picture/C/icon3/FvIcon_253.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-55',
                        url: '/static/picture/C/icon3/FvIcon_254.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-56',
                        url: '/static/picture/C/icon3/FvIcon_255.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-57',
                        url: '/static/picture/C/icon3/FvIcon_256.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-58',
                        url: '/static/picture/C/icon3/FvIcon_257.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-59',
                        url: '/static/picture/C/icon3/FvIcon_258.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标C-60',
                        url: '/static/picture/C/icon3/FvIcon_259.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-61',
                        url: '/static/picture/C/icon3/FvIcon_260.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-62',
                        url: '/static/picture/C/icon3/FvIcon_261.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-63',
                        url: '/static/picture/C/icon3/FvIcon_262.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-64',
                        url: '/static/picture/C/icon3/FvIcon_263.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-65',
                        url: '/static/picture/C/icon3/FvIcon_264.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-66',
                        url: '/static/picture/C/icon3/FvIcon_265.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-67',
                        url: '/static/picture/C/icon3/FvIcon_266.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-68',
                        url: '/static/picture/C/icon3/FvIcon_267.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-69',
                        url: '/static/picture/C/icon3/FvIcon_268.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-70',
                        url: '/static/picture/C/icon3/FvIcon_269.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标C-71',
                        url: '/static/picture/C/icon3/FvIcon_270.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-72',
                        url: '/static/picture/C/icon3/FvIcon_271.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-73',
                        url: '/static/picture/C/icon3/FvIcon_272.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-74',
                        url: '/static/picture/C/icon3/FvIcon_273.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-75',
                        url: '/static/picture/C/icon3/FvIcon_274.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-76',
                        url: '/static/picture/C/icon3/FvIcon_275.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-77',
                        url: '/static/picture/C/icon3/FvIcon_276.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-78',
                        url: '/static/picture/C/icon3/FvIcon_277.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-79',
                        url: '/static/picture/C/icon3/FvIcon_278.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-80',
                        url: '/static/picture/C/icon3/FvIcon_279.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-81',
                        url: '/static/picture/C/icon3/FvIcon_280.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标C-82',
                        url: '/static/picture/C/icon3/FvIcon_281.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-83',
                        url: '/static/picture/C/icon3/FvIcon_282.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-84',
                        url: '/static/picture/C/icon3/FvIcon_283.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-85',
                        url: '/static/picture/C/icon3/FvIcon_284.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-86',
                        url: '/static/picture/C/icon3/FvIcon_285.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-87',
                        url: '/static/picture/C/icon3/FvIcon_286.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-88',
                        url: '/static/picture/C/icon3/FvIcon_287.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-89',
                        url: '/static/picture/C/icon3/FvIcon_288.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-90',
                        url: '/static/picture/C/icon3/FvIcon_289.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-91',
                        url: '/static/picture/C/icon3/FvIcon_290.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-92',
                        url: '/static/picture/C/icon3/FvIcon_291.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标C-93',
                        url: '/static/picture/C/icon3/FvIcon_292.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-94',
                        url: '/static/picture/C/icon3/FvIcon_293.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-95',
                        url: '/static/picture/C/icon3/FvIcon_294.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-96',
                        url: '/static/picture/C/icon3/FvIcon_295.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-97',
                        url: '/static/picture/C/icon3/FvIcon_296.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-98',
                        url: '/static/picture/C/icon3/FvIcon_297.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-99',
                        url: '/static/picture/C/icon3/FvIcon_298.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标C-100',
                        url: '/static/picture/C/icon3/FvIcon_299.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 3, name: '图标D', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '图标D-1',
                        url: '/static/picture/C/icon4/FvIcon_400.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-2',
                        url: '/static/picture/C/icon4/FvIcon_301.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-3',
                        url: '/static/picture/C/icon4/FvIcon_302.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-4',
                        url: '/static/picture/C/icon4/FvIcon_303.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-5',
                        url: '/static/picture/C/icon4/FvIcon_304.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-6',
                        url: '/static/picture/C/icon4/FvIcon_305.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-7',
                        url: '/static/picture/C/icon4/FvIcon_306.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-8',
                        url: '/static/picture/C/icon4/FvIcon_307.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-9',
                        url: '/static/picture/C/icon4/FvIcon_308.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-10',
                        url: '/static/picture/C/icon4/FvIcon_309.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-11',
                        url: '/static/picture/C/icon4/FvIcon_310.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-12',
                        url: '/static/picture/C/icon4/FvIcon_311.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-13',
                        url: '/static/picture/C/icon4/FvIcon_312.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-14',
                        url: '/static/picture/C/icon4/FvIcon_313.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-15',
                        url: '/static/picture/C/icon4/FvIcon_314.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标D-16',
                        url: '/static/picture/C/icon4/FvIcon_315.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-17',
                        url: '/static/picture/C/icon4/FvIcon_316.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-18',
                        url: '/static/picture/C/icon4/FvIcon_317.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-19',
                        url: '/static/picture/C/icon4/FvIcon_318.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-20',
                        url: '/static/picture/C/icon4/FvIcon_319.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-21',
                        url: '/static/picture/C/icon4/FvIcon_320.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-22',
                        url: '/static/picture/C/icon4/FvIcon_321.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-23',
                        url: '/static/picture/C/icon4/FvIcon_322.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-24',
                        url: '/static/picture/C/icon4/FvIcon_323.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-25',
                        url: '/static/picture/C/icon4/FvIcon_324.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-26',
                        url: '/static/picture/C/icon4/FvIcon_325.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标D-27',
                        url: '/static/picture/C/icon4/FvIcon_326.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-28',
                        url: '/static/picture/C/icon4/FvIcon_327.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-29',
                        url: '/static/picture/C/icon4/FvIcon_328.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-30',
                        url: '/static/picture/C/icon4/FvIcon_329.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-31',
                        url: '/static/picture/C/icon4/FvIcon_330.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-32',
                        url: '/static/picture/C/icon4/FvIcon_331.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-33',
                        url: '/static/picture/C/icon4/FvIcon_332.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-34',
                        url: '/static/picture/C/icon4/FvIcon_333.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-35',
                        url: '/static/picture/C/icon4/FvIcon_334.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-36',
                        url: '/static/picture/C/icon4/FvIcon_335.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-37',
                        url: '/static/picture/C/icon4/FvIcon_336.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标D-38',
                        url: '/static/picture/C/icon4/FvIcon_337.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-39',
                        url: '/static/picture/C/icon4/FvIcon_338.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-40',
                        url: '/static/picture/C/icon4/FvIcon_339.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-41',
                        url: '/static/picture/C/icon4/FvIcon_340.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-42',
                        url: '/static/picture/C/icon4/FvIcon_341.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-43',
                        url: '/static/picture/C/icon4/FvIcon_342.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-44',
                        url: '/static/picture/C/icon4/FvIcon_343.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-45',
                        url: '/static/picture/C/icon4/FvIcon_344.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-46',
                        url: '/static/picture/C/icon4/FvIcon_345.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-47',
                        url: '/static/picture/C/icon4/FvIcon_346.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-48',
                        url: '/static/picture/C/icon4/FvIcon_347.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标D-49',
                        url: '/static/picture/C/icon4/FvIcon_348.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-50',
                        url: '/static/picture/C/icon4/FvIcon_349.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-51',
                        url: '/static/picture/C/icon4/FvIcon_350.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-52',
                        url: '/static/picture/C/icon4/FvIcon_351.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-53',
                        url: '/static/picture/C/icon4/FvIcon_352.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-54',
                        url: '/static/picture/C/icon4/FvIcon_353.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-55',
                        url: '/static/picture/C/icon4/FvIcon_354.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-56',
                        url: '/static/picture/C/icon4/FvIcon_355.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-57',
                        url: '/static/picture/C/icon4/FvIcon_356.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-58',
                        url: '/static/picture/C/icon4/FvIcon_357.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-59',
                        url: '/static/picture/C/icon4/FvIcon_358.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标D-60',
                        url: '/static/picture/C/icon4/FvIcon_359.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-61',
                        url: '/static/picture/C/icon4/FvIcon_360.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-62',
                        url: '/static/picture/C/icon4/FvIcon_361.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-63',
                        url: '/static/picture/C/icon4/FvIcon_362.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-64',
                        url: '/static/picture/C/icon4/FvIcon_363.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-65',
                        url: '/static/picture/C/icon4/FvIcon_364.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-66',
                        url: '/static/picture/C/icon4/FvIcon_365.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-67',
                        url: '/static/picture/C/icon4/FvIcon_366.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-68',
                        url: '/static/picture/C/icon4/FvIcon_367.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-69',
                        url: '/static/picture/C/icon4/FvIcon_368.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-70',
                        url: '/static/picture/C/icon4/FvIcon_369.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标D-71',
                        url: '/static/picture/C/icon4/FvIcon_370.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-72',
                        url: '/static/picture/C/icon4/FvIcon_371.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-73',
                        url: '/static/picture/C/icon4/FvIcon_372.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-74',
                        url: '/static/picture/C/icon4/FvIcon_373.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-75',
                        url: '/static/picture/C/icon4/FvIcon_374.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-76',
                        url: '/static/picture/C/icon4/FvIcon_375.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-77',
                        url: '/static/picture/C/icon4/FvIcon_376.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-78',
                        url: '/static/picture/C/icon4/FvIcon_377.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-79',
                        url: '/static/picture/C/icon4/FvIcon_378.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-80',
                        url: '/static/picture/C/icon4/FvIcon_379.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-81',
                        url: '/static/picture/C/icon4/FvIcon_380.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标D-82',
                        url: '/static/picture/C/icon4/FvIcon_381.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-83',
                        url: '/static/picture/C/icon4/FvIcon_382.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-84',
                        url: '/static/picture/C/icon4/FvIcon_383.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-85',
                        url: '/static/picture/C/icon4/FvIcon_384.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-86',
                        url: '/static/picture/C/icon4/FvIcon_385.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-87',
                        url: '/static/picture/C/icon4/FvIcon_386.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-88',
                        url: '/static/picture/C/icon4/FvIcon_387.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-89',
                        url: '/static/picture/C/icon4/FvIcon_388.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-90',
                        url: '/static/picture/C/icon4/FvIcon_389.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-91',
                        url: '/static/picture/C/icon4/FvIcon_390.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-92',
                        url: '/static/picture/C/icon4/FvIcon_391.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标D-93',
                        url: '/static/picture/C/icon4/FvIcon_392.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-94',
                        url: '/static/picture/C/icon4/FvIcon_393.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-95',
                        url: '/static/picture/C/icon4/FvIcon_394.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-96',
                        url: '/static/picture/C/icon4/FvIcon_395.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-97',
                        url: '/static/picture/C/icon4/FvIcon_396.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-98',
                        url: '/static/picture/C/icon4/FvIcon_397.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-99',
                        url: '/static/picture/C/icon4/FvIcon_398.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标D-100',
                        url: '/static/picture/C/icon4/FvIcon_399.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 4, name: '图标E', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '图标E-1',
                        url: '/static/picture/C/icon5/FvIcon_500.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-2',
                        url: '/static/picture/C/icon5/FvIcon_401.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-3',
                        url: '/static/picture/C/icon5/FvIcon_402.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-4',
                        url: '/static/picture/C/icon5/FvIcon_403.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-5',
                        url: '/static/picture/C/icon5/FvIcon_404.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-6',
                        url: '/static/picture/C/icon5/FvIcon_405.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-7',
                        url: '/static/picture/C/icon5/FvIcon_406.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-8',
                        url: '/static/picture/C/icon5/FvIcon_407.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-9',
                        url: '/static/picture/C/icon5/FvIcon_408.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-10',
                        url: '/static/picture/C/icon5/FvIcon_409.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-11',
                        url: '/static/picture/C/icon5/FvIcon_410.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-12',
                        url: '/static/picture/C/icon5/FvIcon_411.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-13',
                        url: '/static/picture/C/icon5/FvIcon_412.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-14',
                        url: '/static/picture/C/icon5/FvIcon_413.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-15',
                        url: '/static/picture/C/icon5/FvIcon_414.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标E-16',
                        url: '/static/picture/C/icon5/FvIcon_415.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-17',
                        url: '/static/picture/C/icon5/FvIcon_416.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-18',
                        url: '/static/picture/C/icon5/FvIcon_417.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-19',
                        url: '/static/picture/C/icon5/FvIcon_418.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-20',
                        url: '/static/picture/C/icon5/FvIcon_419.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-21',
                        url: '/static/picture/C/icon5/FvIcon_420.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-22',
                        url: '/static/picture/C/icon5/FvIcon_421.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-23',
                        url: '/static/picture/C/icon5/FvIcon_422.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-24',
                        url: '/static/picture/C/icon5/FvIcon_423.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-25',
                        url: '/static/picture/C/icon5/FvIcon_424.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-26',
                        url: '/static/picture/C/icon5/FvIcon_425.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标E-27',
                        url: '/static/picture/C/icon5/FvIcon_426.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-28',
                        url: '/static/picture/C/icon5/FvIcon_427.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-29',
                        url: '/static/picture/C/icon5/FvIcon_428.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-30',
                        url: '/static/picture/C/icon5/FvIcon_429.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-31',
                        url: '/static/picture/C/icon5/FvIcon_430.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-32',
                        url: '/static/picture/C/icon5/FvIcon_431.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-33',
                        url: '/static/picture/C/icon5/FvIcon_432.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-34',
                        url: '/static/picture/C/icon5/FvIcon_433.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-35',
                        url: '/static/picture/C/icon5/FvIcon_434.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-36',
                        url: '/static/picture/C/icon5/FvIcon_435.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-37',
                        url: '/static/picture/C/icon5/FvIcon_436.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标E-38',
                        url: '/static/picture/C/icon5/FvIcon_437.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-39',
                        url: '/static/picture/C/icon5/FvIcon_438.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-40',
                        url: '/static/picture/C/icon5/FvIcon_439.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-41',
                        url: '/static/picture/C/icon5/FvIcon_440.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-42',
                        url: '/static/picture/C/icon5/FvIcon_441.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-43',
                        url: '/static/picture/C/icon5/FvIcon_442.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-44',
                        url: '/static/picture/C/icon5/FvIcon_443.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-45',
                        url: '/static/picture/C/icon5/FvIcon_444.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-46',
                        url: '/static/picture/C/icon5/FvIcon_445.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-47',
                        url: '/static/picture/C/icon5/FvIcon_446.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-48',
                        url: '/static/picture/C/icon5/FvIcon_447.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标E-49',
                        url: '/static/picture/C/icon5/FvIcon_448.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-50',
                        url: '/static/picture/C/icon5/FvIcon_449.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-51',
                        url: '/static/picture/C/icon5/FvIcon_450.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-52',
                        url: '/static/picture/C/icon5/FvIcon_451.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-53',
                        url: '/static/picture/C/icon5/FvIcon_452.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-54',
                        url: '/static/picture/C/icon5/FvIcon_453.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-55',
                        url: '/static/picture/C/icon5/FvIcon_454.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-56',
                        url: '/static/picture/C/icon5/FvIcon_455.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-57',
                        url: '/static/picture/C/icon5/FvIcon_456.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-58',
                        url: '/static/picture/C/icon5/FvIcon_457.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-59',
                        url: '/static/picture/C/icon5/FvIcon_458.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标E-60',
                        url: '/static/picture/C/icon5/FvIcon_459.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-61',
                        url: '/static/picture/C/icon5/FvIcon_460.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-62',
                        url: '/static/picture/C/icon5/FvIcon_461.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-63',
                        url: '/static/picture/C/icon5/FvIcon_462.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-64',
                        url: '/static/picture/C/icon5/FvIcon_463.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-65',
                        url: '/static/picture/C/icon5/FvIcon_464.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-66',
                        url: '/static/picture/C/icon5/FvIcon_465.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-67',
                        url: '/static/picture/C/icon5/FvIcon_466.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-68',
                        url: '/static/picture/C/icon5/FvIcon_467.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-69',
                        url: '/static/picture/C/icon5/FvIcon_468.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-70',
                        url: '/static/picture/C/icon5/FvIcon_469.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标E-71',
                        url: '/static/picture/C/icon5/FvIcon_470.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-72',
                        url: '/static/picture/C/icon5/FvIcon_471.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-73',
                        url: '/static/picture/C/icon5/FvIcon_472.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-74',
                        url: '/static/picture/C/icon5/FvIcon_473.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-75',
                        url: '/static/picture/C/icon5/FvIcon_474.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-76',
                        url: '/static/picture/C/icon5/FvIcon_475.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-77',
                        url: '/static/picture/C/icon5/FvIcon_476.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-78',
                        url: '/static/picture/C/icon5/FvIcon_477.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-79',
                        url: '/static/picture/C/icon5/FvIcon_478.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-80',
                        url: '/static/picture/C/icon5/FvIcon_479.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-81',
                        url: '/static/picture/C/icon5/FvIcon_480.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标E-82',
                        url: '/static/picture/C/icon5/FvIcon_481.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-83',
                        url: '/static/picture/C/icon5/FvIcon_482.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-84',
                        url: '/static/picture/C/icon5/FvIcon_483.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-85',
                        url: '/static/picture/C/icon5/FvIcon_484.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-86',
                        url: '/static/picture/C/icon5/FvIcon_485.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-87',
                        url: '/static/picture/C/icon5/FvIcon_486.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-88',
                        url: '/static/picture/C/icon5/FvIcon_487.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-89',
                        url: '/static/picture/C/icon5/FvIcon_488.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-90',
                        url: '/static/picture/C/icon5/FvIcon_489.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-91',
                        url: '/static/picture/C/icon5/FvIcon_490.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-92',
                        url: '/static/picture/C/icon5/FvIcon_491.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标E-93',
                        url: '/static/picture/C/icon5/FvIcon_492.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-94',
                        url: '/static/picture/C/icon5/FvIcon_493.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-95',
                        url: '/static/picture/C/icon5/FvIcon_494.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-96',
                        url: '/static/picture/C/icon5/FvIcon_495.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-97',
                        url: '/static/picture/C/icon5/FvIcon_496.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-98',
                        url: '/static/picture/C/icon5/FvIcon_497.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-99',
                        url: '/static/picture/C/icon5/FvIcon_498.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标E-100',
                        url: '/static/picture/C/icon5/FvIcon_499.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 5, name: '图标F', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '图标F-1',
                        url: '/static/picture/C/icon6/FvIcon_538.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-2',
                        url: '/static/picture/C/icon6/FvIcon_501.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-3',
                        url: '/static/picture/C/icon6/FvIcon_502.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-4',
                        url: '/static/picture/C/icon6/FvIcon_503.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-5',
                        url: '/static/picture/C/icon6/FvIcon_504.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-6',
                        url: '/static/picture/C/icon6/FvIcon_505.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-7',
                        url: '/static/picture/C/icon6/FvIcon_506.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-8',
                        url: '/static/picture/C/icon6/FvIcon_507.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-9',
                        url: '/static/picture/C/icon6/FvIcon_508.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-10',
                        url: '/static/picture/C/icon6/FvIcon_509.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-11',
                        url: '/static/picture/C/icon6/FvIcon_510.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-12',
                        url: '/static/picture/C/icon6/FvIcon_511.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-13',
                        url: '/static/picture/C/icon6/FvIcon_512.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-14',
                        url: '/static/picture/C/icon6/FvIcon_513.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-15',
                        url: '/static/picture/C/icon6/FvIcon_514.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标F-16',
                        url: '/static/picture/C/icon6/FvIcon_515.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-17',
                        url: '/static/picture/C/icon6/FvIcon_516.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-18',
                        url: '/static/picture/C/icon6/FvIcon_517.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-19',
                        url: '/static/picture/C/icon6/FvIcon_518.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-20',
                        url: '/static/picture/C/icon6/FvIcon_519.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-21',
                        url: '/static/picture/C/icon6/FvIcon_520.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-22',
                        url: '/static/picture/C/icon6/FvIcon_521.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-23',
                        url: '/static/picture/C/icon6/FvIcon_522.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-24',
                        url: '/static/picture/C/icon6/FvIcon_523.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-25',
                        url: '/static/picture/C/icon6/FvIcon_524.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-26',
                        url: '/static/picture/C/icon6/FvIcon_525.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标F-27',
                        url: '/static/picture/C/icon6/FvIcon_526.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-28',
                        url: '/static/picture/C/icon6/FvIcon_527.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-29',
                        url: '/static/picture/C/icon6/FvIcon_528.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-30',
                        url: '/static/picture/C/icon6/FvIcon_529.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-31',
                        url: '/static/picture/C/icon6/FvIcon_530.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-32',
                        url: '/static/picture/C/icon6/FvIcon_531.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-33',
                        url: '/static/picture/C/icon6/FvIcon_532.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-34',
                        url: '/static/picture/C/icon6/FvIcon_533.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-35',
                        url: '/static/picture/C/icon6/FvIcon_534.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-36',
                        url: '/static/picture/C/icon6/FvIcon_535.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标F-37',
                        url: '/static/picture/C/icon6/FvIcon_536.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标F-38',
                        url: '/static/picture/C/icon6/FvIcon_537.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 6, name: '图标G', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '图标G-1',
                        url: '/static/picture/C/icon7/FvIcon_700.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-2',
                        url: '/static/picture/C/icon7/FvIcon_601.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-3',
                        url: '/static/picture/C/icon7/FvIcon_602.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-4',
                        url: '/static/picture/C/icon7/FvIcon_603.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-5',
                        url: '/static/picture/C/icon7/FvIcon_604.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-6',
                        url: '/static/picture/C/icon7/FvIcon_605.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-7',
                        url: '/static/picture/C/icon7/FvIcon_606.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-8',
                        url: '/static/picture/C/icon7/FvIcon_607.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-9',
                        url: '/static/picture/C/icon7/FvIcon_608.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-10',
                        url: '/static/picture/C/icon7/FvIcon_609.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-11',
                        url: '/static/picture/C/icon7/FvIcon_610.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-12',
                        url: '/static/picture/C/icon7/FvIcon_611.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-13',
                        url: '/static/picture/C/icon7/FvIcon_612.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-14',
                        url: '/static/picture/C/icon7/FvIcon_613.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-15',
                        url: '/static/picture/C/icon7/FvIcon_614.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标G-16',
                        url: '/static/picture/C/icon7/FvIcon_615.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-17',
                        url: '/static/picture/C/icon7/FvIcon_616.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-18',
                        url: '/static/picture/C/icon7/FvIcon_617.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-19',
                        url: '/static/picture/C/icon7/FvIcon_618.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-20',
                        url: '/static/picture/C/icon7/FvIcon_619.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-21',
                        url: '/static/picture/C/icon7/FvIcon_620.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-22',
                        url: '/static/picture/C/icon7/FvIcon_621.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-23',
                        url: '/static/picture/C/icon7/FvIcon_622.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-24',
                        url: '/static/picture/C/icon7/FvIcon_623.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-25',
                        url: '/static/picture/C/icon7/FvIcon_624.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-26',
                        url: '/static/picture/C/icon7/FvIcon_625.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标G-27',
                        url: '/static/picture/C/icon7/FvIcon_626.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-28',
                        url: '/static/picture/C/icon7/FvIcon_627.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-29',
                        url: '/static/picture/C/icon7/FvIcon_628.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-30',
                        url: '/static/picture/C/icon7/FvIcon_629.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-31',
                        url: '/static/picture/C/icon7/FvIcon_630.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-32',
                        url: '/static/picture/C/icon7/FvIcon_631.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-33',
                        url: '/static/picture/C/icon7/FvIcon_632.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-34',
                        url: '/static/picture/C/icon7/FvIcon_633.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-35',
                        url: '/static/picture/C/icon7/FvIcon_634.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-36',
                        url: '/static/picture/C/icon7/FvIcon_635.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-37',
                        url: '/static/picture/C/icon7/FvIcon_636.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标G-38',
                        url: '/static/picture/C/icon7/FvIcon_637.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-39',
                        url: '/static/picture/C/icon7/FvIcon_638.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-40',
                        url: '/static/picture/C/icon7/FvIcon_639.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-41',
                        url: '/static/picture/C/icon7/FvIcon_640.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-42',
                        url: '/static/picture/C/icon7/FvIcon_641.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-43',
                        url: '/static/picture/C/icon7/FvIcon_642.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-44',
                        url: '/static/picture/C/icon7/FvIcon_643.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-45',
                        url: '/static/picture/C/icon7/FvIcon_644.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-46',
                        url: '/static/picture/C/icon7/FvIcon_645.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-47',
                        url: '/static/picture/C/icon7/FvIcon_646.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-48',
                        url: '/static/picture/C/icon7/FvIcon_647.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标G-49',
                        url: '/static/picture/C/icon7/FvIcon_648.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-50',
                        url: '/static/picture/C/icon7/FvIcon_649.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-51',
                        url: '/static/picture/C/icon7/FvIcon_650.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-52',
                        url: '/static/picture/C/icon7/FvIcon_651.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-53',
                        url: '/static/picture/C/icon7/FvIcon_652.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-54',
                        url: '/static/picture/C/icon7/FvIcon_653.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-55',
                        url: '/static/picture/C/icon7/FvIcon_654.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-56',
                        url: '/static/picture/C/icon7/FvIcon_655.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-57',
                        url: '/static/picture/C/icon7/FvIcon_656.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-58',
                        url: '/static/picture/C/icon7/FvIcon_657.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-59',
                        url: '/static/picture/C/icon7/FvIcon_658.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标G-60',
                        url: '/static/picture/C/icon7/FvIcon_659.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-61',
                        url: '/static/picture/C/icon7/FvIcon_660.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-62',
                        url: '/static/picture/C/icon7/FvIcon_661.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-63',
                        url: '/static/picture/C/icon7/FvIcon_662.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-64',
                        url: '/static/picture/C/icon7/FvIcon_663.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-65',
                        url: '/static/picture/C/icon7/FvIcon_664.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-66',
                        url: '/static/picture/C/icon7/FvIcon_665.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-67',
                        url: '/static/picture/C/icon7/FvIcon_666.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-68',
                        url: '/static/picture/C/icon7/FvIcon_667.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-69',
                        url: '/static/picture/C/icon7/FvIcon_668.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-70',
                        url: '/static/picture/C/icon7/FvIcon_669.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标G-71',
                        url: '/static/picture/C/icon7/FvIcon_670.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-72',
                        url: '/static/picture/C/icon7/FvIcon_671.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-73',
                        url: '/static/picture/C/icon7/FvIcon_672.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-74',
                        url: '/static/picture/C/icon7/FvIcon_673.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-75',
                        url: '/static/picture/C/icon7/FvIcon_674.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-76',
                        url: '/static/picture/C/icon7/FvIcon_675.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-77',
                        url: '/static/picture/C/icon7/FvIcon_676.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-78',
                        url: '/static/picture/C/icon7/FvIcon_677.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-79',
                        url: '/static/picture/C/icon7/FvIcon_678.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-80',
                        url: '/static/picture/C/icon7/FvIcon_679.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-81',
                        url: '/static/picture/C/icon7/FvIcon_680.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标G-82',
                        url: '/static/picture/C/icon7/FvIcon_681.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-83',
                        url: '/static/picture/C/icon7/FvIcon_682.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-84',
                        url: '/static/picture/C/icon7/FvIcon_683.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-85',
                        url: '/static/picture/C/icon7/FvIcon_684.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-86',
                        url: '/static/picture/C/icon7/FvIcon_685.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-87',
                        url: '/static/picture/C/icon7/FvIcon_686.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-88',
                        url: '/static/picture/C/icon7/FvIcon_687.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-89',
                        url: '/static/picture/C/icon7/FvIcon_688.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-90',
                        url: '/static/picture/C/icon7/FvIcon_689.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-91',
                        url: '/static/picture/C/icon7/FvIcon_690.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-92',
                        url: '/static/picture/C/icon7/FvIcon_691.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '图标G-93',
                        url: '/static/picture/C/icon7/FvIcon_692.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-94',
                        url: '/static/picture/C/icon7/FvIcon_693.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-95',
                        url: '/static/picture/C/icon7/FvIcon_694.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-96',
                        url: '/static/picture/C/icon7/FvIcon_695.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-97',
                        url: '/static/picture/C/icon7/FvIcon_696.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-98',
                        url: '/static/picture/C/icon7/FvIcon_697.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-99',
                        url: '/static/picture/C/icon7/FvIcon_698.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标G-100',
                        url: '/static/picture/C/icon7/FvIcon_699.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 7, name: '图标H', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '图标H-1',
                        url: '/static/picture/C/icon8/FvIcon_715.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标H-2',
                        url: '/static/picture/C/icon8/FvIcon_701.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标H-3',
                        url: '/static/picture/C/icon8/FvIcon_702.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标H-4',
                        url: '/static/picture/C/icon8/FvIcon_703.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标H-5',
                        url: '/static/picture/C/icon8/FvIcon_704.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标H-6',
                        url: '/static/picture/C/icon8/FvIcon_705.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标H-7',
                        url: '/static/picture/C/icon8/FvIcon_706.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标H-8',
                        url: '/static/picture/C/icon8/FvIcon_707.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标H-9',
                        url: '/static/picture/C/icon8/FvIcon_708.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标H-10',
                        url: '/static/picture/C/icon8/FvIcon_709.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标H-11',
                        url: '/static/picture/C/icon8/FvIcon_710.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标H-12',
                        url: '/static/picture/C/icon8/FvIcon_711.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标H-13',
                        url: '/static/picture/C/icon8/FvIcon_712.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标H-14',
                        url: '/static/picture/C/icon8/FvIcon_713.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '图标H-15',
                        url: '/static/picture/C/icon8/FvIcon_714.ico',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
        ],
        showContent: false,
    },
    {
        id: 4,
        name: '其他图形',
        type: [
            {
                id0: 0, name: '其他图形A', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '其他A-1',
                        url: '/static/picture/D/other1/fmother (100).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-2',
                        url: '/static/picture/D/other1/fmother (1).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-3',
                        url: '/static/picture/D/other1/fmother (2).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-4',
                        url: '/static/picture/D/other1/fmother (3).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-5',
                        url: '/static/picture/D/other1/fmother (4).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-6',
                        url: '/static/picture/D/other1/fmother (5).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-7',
                        url: '/static/picture/D/other1/fmother (6).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-8',
                        url: '/static/picture/D/other1/fmother (7).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-9',
                        url: '/static/picture/D/other1/fmother (8).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-10',
                        url: '/static/picture/D/other1/fmother (9).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-11',
                        url: '/static/picture/D/other1/fmother (10).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-12',
                        url: '/static/picture/D/other1/fmother (11).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-13',
                        url: '/static/picture/D/other1/fmother (12).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-14',
                        url: '/static/picture/D/other1/fmother (13).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-15',
                        url: '/static/picture/D/other1/fmother (14).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '其他A-16',
                        url: '/static/picture/D/other1/fmother (15).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-17',
                        url: '/static/picture/D/other1/fmother (16).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-18',
                        url: '/static/picture/D/other1/fmother (17).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-19',
                        url: '/static/picture/D/other1/fmother (18).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-20',
                        url: '/static/picture/D/other1/fmother (19).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-21',
                        url: '/static/picture/D/other1/fmother (20).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-22',
                        url: '/static/picture/D/other1/fmother (21).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-23',
                        url: '/static/picture/D/other1/fmother (22).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-24',
                        url: '/static/picture/D/other1/fmother (23).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-25',
                        url: '/static/picture/D/other1/fmother (24).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-26',
                        url: '/static/picture/D/other1/fmother (25).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '其他A-27',
                        url: '/static/picture/D/other1/fmother (26).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-28',
                        url: '/static/picture/D/other1/fmother (27).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-29',
                        url: '/static/picture/D/other1/fmother (28).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-30',
                        url: '/static/picture/D/other1/fmother (29).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-31',
                        url: '/static/picture/D/other1/fmother (30).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-32',
                        url: '/static/picture/D/other1/fmother (31).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-33',
                        url: '/static/picture/D/other1/fmother (32).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-34',
                        url: '/static/picture/D/other1/fmother (33).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-35',
                        url: '/static/picture/D/other1/fmother (34).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-36',
                        url: '/static/picture/D/other1/fmother (35).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-37',
                        url: '/static/picture/D/other1/fmother (36).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '其他A-38',
                        url: '/static/picture/D/other1/fmother (37).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-39',
                        url: '/static/picture/D/other1/fmother (38).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-40',
                        url: '/static/picture/D/other1/fmother (39).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-41',
                        url: '/static/picture/D/other1/fmother (40).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-42',
                        url: '/static/picture/D/other1/fmother (41).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-43',
                        url: '/static/picture/D/other1/fmother (42).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-44',
                        url: '/static/picture/D/other1/fmother (43).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-45',
                        url: '/static/picture/D/other1/fmother (44).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-46',
                        url: '/static/picture/D/other1/fmother (45).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-47',
                        url: '/static/picture/D/other1/fmother (46).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-48',
                        url: '/static/picture/D/other1/fmother (47).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '其他A-49',
                        url: '/static/picture/D/other1/fmother (48).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-50',
                        url: '/static/picture/D/other1/fmother (49).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-51',
                        url: '/static/picture/D/other1/fmother (50).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-52',
                        url: '/static/picture/D/other1/fmother (51).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-53',
                        url: '/static/picture/D/other1/fmother (52).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-54',
                        url: '/static/picture/D/other1/fmother (53).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-55',
                        url: '/static/picture/D/other1/fmother (54).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-56',
                        url: '/static/picture/D/other1/fmother (55).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-57',
                        url: '/static/picture/D/other1/fmother (56).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-58',
                        url: '/static/picture/D/other1/fmother (57).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-59',
                        url: '/static/picture/D/other1/fmother (58).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '其他A-60',
                        url: '/static/picture/D/other1/fmother (59).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-61',
                        url: '/static/picture/D/other1/fmother (60).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-62',
                        url: '/static/picture/D/other1/fmother (61).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-63',
                        url: '/static/picture/D/other1/fmother (62).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-64',
                        url: '/static/picture/D/other1/fmother (63).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-65',
                        url: '/static/picture/D/other1/fmother (64).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-66',
                        url: '/static/picture/D/other1/fmother (65).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-67',
                        url: '/static/picture/D/other1/fmother (66).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-68',
                        url: '/static/picture/D/other1/fmother (67).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-69',
                        url: '/static/picture/D/other1/fmother (68).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-70',
                        url: '/static/picture/D/other1/fmother (69).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '其他A-71',
                        url: '/static/picture/D/other1/fmother (70).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-72',
                        url: '/static/picture/D/other1/fmother (71).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-73',
                        url: '/static/picture/D/other1/fmother (72).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-74',
                        url: '/static/picture/D/other1/fmother (73).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-75',
                        url: '/static/picture/D/other1/fmother (74).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-76',
                        url: '/static/picture/D/other1/fmother (75).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-77',
                        url: '/static/picture/D/other1/fmother (76).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-78',
                        url: '/static/picture/D/other1/fmother (77).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-79',
                        url: '/static/picture/D/other1/fmother (78).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-80',
                        url: '/static/picture/D/other1/fmother (79).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-81',
                        url: '/static/picture/D/other1/fmother (80).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '其他A-82',
                        url: '/static/picture/D/other1/fmother (81).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-83',
                        url: '/static/picture/D/other1/fmother (82).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-84',
                        url: '/static/picture/D/other1/fmother (83).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-85',
                        url: '/static/picture/D/other1/fmother (84).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-86',
                        url: '/static/picture/D/other1/fmother (85).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-87',
                        url: '/static/picture/D/other1/fmother (86).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-88',
                        url: '/static/picture/D/other1/fmother (87).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-89',
                        url: '/static/picture/D/other1/fmother (88).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-90',
                        url: '/static/picture/D/other1/fmother (89).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-91',
                        url: '/static/picture/D/other1/fmother (90).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-92',
                        url: '/static/picture/D/other1/fmother (91).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '其他A-93',
                        url: '/static/picture/D/other1/fmother (92).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-94',
                        url: '/static/picture/D/other1/fmother (93).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-95',
                        url: '/static/picture/D/other1/fmother (94).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-96',
                        url: '/static/picture/D/other1/fmother (95).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-97',
                        url: '/static/picture/D/other1/fmother (96).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-98',
                        url: '/static/picture/D/other1/fmother (97).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-99',
                        url: '/static/picture/D/other1/fmother (98).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他A-100',
                        url: '/static/picture/D/other1/fmother (99).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 1, name: '其他图形B', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '其他B-1',
                        url: '/static/picture/D/other2/fmother (197).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-2',
                        url: '/static/picture/D/other2/fmother (101).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-3',
                        url: '/static/picture/D/other2/fmother (102).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-4',
                        url: '/static/picture/D/other2/fmother (103).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-5',
                        url: '/static/picture/D/other2/fmother (104).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-6',
                        url: '/static/picture/D/other2/fmother (105).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-7',
                        url: '/static/picture/D/other2/fmother (106).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-8',
                        url: '/static/picture/D/other2/fmother (107).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-9',
                        url: '/static/picture/D/other2/fmother (108).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-10',
                        url: '/static/picture/D/other2/fmother (109).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-11',
                        url: '/static/picture/D/other2/fmother (110).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-12',
                        url: '/static/picture/D/other2/fmother (111).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-13',
                        url: '/static/picture/D/other2/fmother (112).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-14',
                        url: '/static/picture/D/other2/fmother (113).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-15',
                        url: '/static/picture/D/other2/fmother (114).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '其他B-16',
                        url: '/static/picture/D/other2/fmother (115).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-17',
                        url: '/static/picture/D/other2/fmother (116).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-18',
                        url: '/static/picture/D/other2/fmother (117).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-19',
                        url: '/static/picture/D/other2/fmother (118).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-20',
                        url: '/static/picture/D/other2/fmother (119).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-21',
                        url: '/static/picture/D/other2/fmother (120).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-22',
                        url: '/static/picture/D/other2/fmother (121).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-23',
                        url: '/static/picture/D/other2/fmother (122).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-24',
                        url: '/static/picture/D/other2/fmother (123).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-25',
                        url: '/static/picture/D/other2/fmother (124).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-26',
                        url: '/static/picture/D/other2/fmother (125).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '其他B-27',
                        url: '/static/picture/D/other2/fmother (126).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-28',
                        url: '/static/picture/D/other2/fmother (127).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-29',
                        url: '/static/picture/D/other2/fmother (128).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-30',
                        url: '/static/picture/D/other2/fmother (129).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-31',
                        url: '/static/picture/D/other2/fmother (130).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-32',
                        url: '/static/picture/D/other2/fmother (131).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-33',
                        url: '/static/picture/D/other2/fmother (132).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-34',
                        url: '/static/picture/D/other2/fmother (133).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-35',
                        url: '/static/picture/D/other2/fmother (134).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-36',
                        url: '/static/picture/D/other2/fmother (135).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-37',
                        url: '/static/picture/D/other2/fmother (136).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '其他B-38',
                        url: '/static/picture/D/other2/fmother (137).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-39',
                        url: '/static/picture/D/other2/fmother (138).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-40',
                        url: '/static/picture/D/other2/fmother (139).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-41',
                        url: '/static/picture/D/other2/fmother (140).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-42',
                        url: '/static/picture/D/other2/fmother (141).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-43',
                        url: '/static/picture/D/other2/fmother (142).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-44',
                        url: '/static/picture/D/other2/fmother (143).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-45',
                        url: '/static/picture/D/other2/fmother (144).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-46',
                        url: '/static/picture/D/other2/fmother (145).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-47',
                        url: '/static/picture/D/other2/fmother (146).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-48',
                        url: '/static/picture/D/other2/fmother (147).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '其他B-49',
                        url: '/static/picture/D/other2/fmother (148).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-50',
                        url: '/static/picture/D/other2/fmother (149).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-51',
                        url: '/static/picture/D/other2/fmother (150).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-52',
                        url: '/static/picture/D/other2/fmother (151).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-53',
                        url: '/static/picture/D/other2/fmother (152).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-54',
                        url: '/static/picture/D/other2/fmother (153).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-55',
                        url: '/static/picture/D/other2/fmother (154).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-56',
                        url: '/static/picture/D/other2/fmother (155).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-57',
                        url: '/static/picture/D/other2/fmother (156).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-58',
                        url: '/static/picture/D/other2/fmother (157).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-59',
                        url: '/static/picture/D/other2/fmother (158).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '其他B-60',
                        url: '/static/picture/D/other2/fmother (159).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-61',
                        url: '/static/picture/D/other2/fmother (160).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-62',
                        url: '/static/picture/D/other2/fmother (161).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-63',
                        url: '/static/picture/D/other2/fmother (162).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-64',
                        url: '/static/picture/D/other2/fmother (163).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-65',
                        url: '/static/picture/D/other2/fmother (164).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-66',
                        url: '/static/picture/D/other2/fmother (165).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-67',
                        url: '/static/picture/D/other2/fmother (166).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-68',
                        url: '/static/picture/D/other2/fmother (167).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-69',
                        url: '/static/picture/D/other2/fmother (168).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-70',
                        url: '/static/picture/D/other2/fmother (169).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '其他B-71',
                        url: '/static/picture/D/other2/fmother (170).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-72',
                        url: '/static/picture/D/other2/fmother (171).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-73',
                        url: '/static/picture/D/other2/fmother (172).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-74',
                        url: '/static/picture/D/other2/fmother (173).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-75',
                        url: '/static/picture/D/other2/fmother (174).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-76',
                        url: '/static/picture/D/other2/fmother (175).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-77',
                        url: '/static/picture/D/other2/fmother (176).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-78',
                        url: '/static/picture/D/other2/fmother (177).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-79',
                        url: '/static/picture/D/other2/fmother (178).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-80',
                        url: '/static/picture/D/other2/fmother (179).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-81',
                        url: '/static/picture/D/other2/fmother (180).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '其他B-82',
                        url: '/static/picture/D/other2/fmother (181).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-83',
                        url: '/static/picture/D/other2/fmother (182).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-84',
                        url: '/static/picture/D/other2/fmother (183).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-85',
                        url: '/static/picture/D/other2/fmother (184).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-86',
                        url: '/static/picture/D/other2/fmother (185).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-87',
                        url: '/static/picture/D/other2/fmother (186).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-88',
                        url: '/static/picture/D/other2/fmother (187).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-89',
                        url: '/static/picture/D/other2/fmother (188).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-90',
                        url: '/static/picture/D/other2/fmother (189).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-91',
                        url: '/static/picture/D/other2/fmother (190).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-92',
                        url: '/static/picture/D/other2/fmother (191).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '其他B-93',
                        url: '/static/picture/D/other2/fmother (192).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-94',
                        url: '/static/picture/D/other2/fmother (193).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-95',
                        url: '/static/picture/D/other2/fmother (194).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-96',
                        url: '/static/picture/D/other2/fmother (195).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他B-97',
                        url: '/static/picture/D/other2/fmother (196).bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 2, name: '其他图形C', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '其他C-1',
                        url: '/static/picture/D/other3/Other01.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他C-2',
                        url: '/static/picture/D/other3/Other02.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他C-3',
                        url: '/static/picture/D/other3/Other03.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他C-4',
                        url: '/static/picture/D/other3/Other04.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他C-5',
                        url: '/static/picture/D/other3/Other05.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他C-6',
                        url: '/static/picture/D/other3/Other06.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他C-7',
                        url: '/static/picture/D/other3/Other07.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他C-8',
                        url: '/static/picture/D/other3/Other08.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他C-9',
                        url: '/static/picture/D/other3/Other09.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他C-10',
                        url: '/static/picture/D/other3/Other10.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他C-11',
                        url: '/static/picture/D/other3/Other11.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他C-12',
                        url: '/static/picture/D/other3/Other12.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他C-13',
                        url: '/static/picture/D/other3/Other13.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他C-14',
                        url: '/static/picture/D/other3/Other14.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他C-15',
                        url: '/static/picture/D/other3/Other15.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    ///////////
                    {
                        type: "img",
                        name: '其他C-16',
                        url: '/static/picture/D/other3/Other16.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他C-17',
                        url: '/static/picture/D/other3/Other17.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '其他C-18',
                        url: '/static/picture/D/other3/Other18.bmp',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
        ],
        showContent: false,
    },

]
